"use client";

import dynamic from "next/dynamic";

const NavBar = dynamic(() => import("@/widgets/navbar/NavBar1"), {
	ssr: true,
});

const NavBar2 = dynamic(() => import("@/widgets/navbar/NavBar2"), {
	ssr: true,
});

const NavBar3 = dynamic(() => import("@/widgets/navbar/NavBar3"), {
	ssr: true,
});

const NavBar4 = dynamic(() => import("@/widgets/navbar/NavBar4"), {
	ssr: true,
});

const NavBar5 = dynamic(() => import("@/widgets/navbar/NavBar5"), {
	ssr: true,
});

const NavBar2000 = dynamic(() => import("@/widgets/navbar/NavBar2000"), {
	ssr: true,
});

const NavBar1047 = dynamic(() => import("@/widgets/navbar/NavBar1047"), {
	ssr: true,
});


const Header1 = dynamic(() => import("@/widgets/header/Header1"), {
	ssr: true,
});

const About1 = dynamic(() => import("@/widgets/about/About1"), {
	ssr: true,
});

const About2 = dynamic(() => import("@/widgets/about/About2"), {
	ssr: true,
});

const InstituteSection = dynamic(
	() => import("@/widgets/about/InstituteSection"),
	{
		ssr: true,
	},
);

const AboutMegaFooter = dynamic(
	() => import("@/widgets/about/AboutMegaFooter"),
	{ ssr: true },
);

const About3 = dynamic(() => import("@/widgets/about/About3"), {
	ssr: true,
});

const Accreditation1 = dynamic(
	() => import("@/widgets/accreditation/Accreditation1"),
	{
		ssr: true,
	},
);

const Accreditation2 = dynamic(
	() => import("@/widgets/accreditation/Accreditation2"),
	{
		ssr: true,
	},
);

const Accreditation3 = dynamic(
	() => import("@/widgets/accreditation/Accreditation3"),
	{
		ssr: true,
	},
);

const Accreditation4 = dynamic(
	() => import("@/widgets/accreditation/Accreditation4"),
	{
		ssr: true,
	},
);

const Accreditation5 = dynamic(
	() => import("@/widgets/accreditation/Accreditation5"),
	{
		ssr: true,
	},
);

const Accreditation1000 = dynamic(
	() => import("@/widgets/accreditation/Accreditation1000"),
	{
		ssr: true,
	},
);

const ProgramCards3 = dynamic(
	() => import("@/widgets/exploreonlinecourses/ProgramCards3"),
	{
		ssr: true,
	},
);

const ProgramCards4 = dynamic(
	() => import("@/widgets/exploreonlinecourses/ProgramCards4"),
	{
		ssr: true,
	},
);

export const Leaddrop7 = dynamic(
	() => import("@/widgets/leaddrop/leaddrop7/index"),
	{
		ssr: true,
	},
);

export const Leaddrop10 = dynamic(
	() => import("@/widgets/leaddrop/leaddrop10/index"),
	{
		ssr: true,
	},
);

// Lead Drop Popup 3 — "Drop a query": saves to the CMS DB only (POST /leads/direct),
// no OTP and no ERP/LSQ push. Available in both standalone and multi-tenant.
export const Leaddrop3 = dynamic(
	() => import("@/widgets/leaddrop/leaddrop3/index"),
	{
		ssr: true,
	},
);

// Lead Drop Popup 4 — single-step form, no OTP; on submit pushes to CRM
// (POST /leads/sync-drop4). Standalone always uses ERP; LSQ is used only for
// multi-tenant microsite hosts.
export const Leaddrop4 = dynamic(
	() => import("@/widgets/leaddrop/leaddrop4/index"),
	{
		ssr: true,
	},
);

const KeyNumbers1 = dynamic(() => import("@/widgets/keynumbers/KeyNumbers1"), {
	ssr: true,
});

const KeyNumbers2 = dynamic(() => import("@/widgets/keynumbers/KeyNumbers2"), {
	ssr: true,
});

const DigitalLearning1 = dynamic(
	() => import("@/widgets/digitalLearning/DigitalLearning1"),
	{ ssr: true },
);

const Scholar1 = dynamic(() => import("@/widgets/scholar/Scholar1"), {
	ssr: true,
});

const Banner1 = dynamic(() => import("@/widgets/banner/Banner1"), {
	ssr: true,
});

const Banner2 = dynamic(() => import("@/widgets/banner/Banner2"), {
	ssr: true,
});

const HeroCarousel = dynamic(() => import("@/widgets/banner/HeroCarousel"), {
	ssr: true,
});

const BannerFeatureGrid = dynamic(
	() => import("@/widgets/banner/BannerFeatureGrid"),
	{ ssr: true },
);

const Banner5 = dynamic(() => import("@/widgets/banner/Banner5"), {
	ssr: true,
});

const Banner3 = dynamic(() => import("@/widgets/banner/Banner3"), {
	ssr: true,
});

const Banner8 = dynamic(() => import("@/widgets/banner/Banner8"), {
	ssr: true,
});

const Banner9 = dynamic(() => import("@/widgets/banner/Banner9"), {
	ssr: true,
});

const Banner15 = dynamic(() => import("@/widgets/banner/Banner15"), {
	ssr: true,
});

const Banner1010 = dynamic(() => import("@/widgets/banner/Banner1010"), {
	ssr: true,
});

const Banner10 = dynamic(() => import("@/widgets/banner/Banner10"), {
	ssr: true,
});

const Banner11 = dynamic(() => import("@/widgets/banner/Banner11"), {
	ssr: true,
});

const Banner3000 = dynamic(() => import("@/widgets/banner/Banner3000"), {
	ssr: true,
});

const Banner3001 = dynamic(() => import("@/widgets/banner/Banner3001"), {
	ssr: true,
});

const Banner5004 = dynamic(() => import("@/widgets/banner/Banner5004"), {
	ssr: true,
});

const KeyNumbers5006 = dynamic(() => import("@/widgets/keynumbers/KeyNumbers5006"), {
	ssr: true,
});

const KeyNumbers5007 = dynamic(() => import("@/widgets/keynumbers/KeyNumbers5007"), {
	ssr: true,
});

const ProgramBenefits5008 = dynamic(() => import("@/widgets/programBenefits/ProgramBenefits5008"), {
	ssr: true,
});

const ProgramBenefits5009 = dynamic(() => import("@/widgets/programBenefits/ProgramBenefits5009"), {
	ssr: true,
});

const Recruiters5010 = dynamic(() => import("@/widgets/recruiters/Recruiters5010"), {
	ssr: true,
});

const ApplicationProcess5011 = dynamic(() => import("@/widgets/applicationprocess/ApplicationProcess5011"), {
	ssr: true,
});

const Eligibility5012 = dynamic(() => import("@/widgets/eligibility/Eligibility5012"), {
	ssr: true,
});

const Faqs5013 = dynamic(() => import("@/widgets/faqs/Faqs5013"), {
	ssr: true,
});

const Footer5014 = dynamic(() => import("@/widgets/footer/Footer5014"), {
	ssr: true,
});

const Header5015 = dynamic(() => import("@/widgets/header/Header5015"), {
	ssr: true,
});

const Header5016 = dynamic(() => import("@/widgets/header/Header5016"), {
	ssr: true,
});

/* --- KUK home page (kukonline.ac.in) — variants 1051-1060 -------------------- */

const Banner1051 = dynamic(() => import("@/widgets/banner/Banner1051"), {
	ssr: true,
});

const Accreditation1052 = dynamic(
	() => import("@/widgets/accreditation/Accreditation1052"),
	{ ssr: true },
);

const ProgramCards1053 = dynamic(
	() => import("@/widgets/exploreonlinecourses/ProgramCards1053"),
	{ ssr: true },
);

const About1054 = dynamic(() => import("@/widgets/about/About1054"), {
	ssr: true,
});

const KeyNumbers1055 = dynamic(
	() => import("@/widgets/keynumbers/KeyNumbers1055"),
	{ ssr: true },
);

const Testimonials1056 = dynamic(
	() => import("@/widgets/studenttestimonials/Testimonials1056"),
	{ ssr: true },
);

const About1057 = dynamic(() => import("@/widgets/about/About1057"), {
	ssr: true,
});

const Banner1058 = dynamic(() => import("@/widgets/banner/Banner1058"), {
	ssr: true,
});

const Banner1059 = dynamic(() => import("@/widgets/banner/Banner1059"), {
	ssr: true,
});

const NavBar1060 = dynamic(() => import("@/widgets/navbar/NavBar1060"), {
	ssr: true,
});

/* --- KUK programme pages (kukonline.ac.in/online-*) — variants 1061-1070 ---- */

const Banner1061 = dynamic(() => import("@/widgets/banner/Banner1061"), {
	ssr: true,
});

const Banner1062 = dynamic(() => import("@/widgets/banner/Banner1062"), {
	ssr: true,
});

const ProgramBenefits1063 = dynamic(
	() => import("@/widgets/programBenefits/ProgramBenefits1063"),
	{ ssr: true },
);

const ProgramStructure1064 = dynamic(
	() => import("@/widgets/programstructure/ProgramStructure1064"),
	{ ssr: true },
);

const Elective1065 = dynamic(() => import("@/widgets/elective/Elective1065"), {
	ssr: true,
});

const ProgramFee1066 = dynamic(
	() => import("@/widgets/programfee/ProgramFee1066"),
	{ ssr: true },
);

const ProgramCards1067 = dynamic(
	() => import("@/widgets/exploreonlinecourses/ProgramCards1067"),
	{ ssr: true },
);

const Banner1068 = dynamic(() => import("@/widgets/banner/Banner1068"), {
	ssr: true,
});

const ProgramBenefits1069 = dynamic(
	() => import("@/widgets/programBenefits/ProgramBenefits1069"),
	{ ssr: true },
);

const ProgramCards1070 = dynamic(
	() => import("@/widgets/exploreonlinecourses/ProgramCards1070"),
	{ ssr: true },
);

const Banner1025 = dynamic(() => import("@/widgets/banner/Banner1025"), {
	ssr: true,
});

const KeyNumbers1026 = dynamic(() => import("@/widgets/keynumbers/KeyNumbers1026"), {
	ssr: true,
});

const ProgramCards1027 = dynamic(() => import("@/widgets/exploreonlinecourses/ProgramCards1027"), {
	ssr: true,
});

const About1028 = dynamic(() => import("@/widgets/about/About1028"), {
	ssr: true,
});

const ProgramBenefits1029 = dynamic(() => import("@/widgets/programBenefits/ProgramBenefits1029"), {
	ssr: true,
});

const ApplicationProcess1030 = dynamic(() => import("@/widgets/applicationprocess/ApplicationProcess1030"), {
	ssr: true,
});

const AcademicDeliverables1031 = dynamic(() => import("@/widgets/academicdeliverables/AcademicDeliverables1031"), {
	ssr: true,
});

const Leaders1032 = dynamic(() => import("@/widgets/leaders/Leaders1032"), {
	ssr: true,
});

const Faqs1033 = dynamic(() => import("@/widgets/faqs/Faqs1033"), {
	ssr: true,
});

const Footer1034 = dynamic(() => import("@/widgets/footer/Footer1034"), {
	ssr: true,
});

const Banner1035 = dynamic(() => import("@/widgets/banner/Banner1035"), {
	ssr: true,
});

const Banner6000 = dynamic(() => import("@/widgets/banner/Banner6000"), {
	ssr: true,
});

const KeyNumbers1036 = dynamic(() => import("@/widgets/keynumbers/KeyNumbers1036"), {
	ssr: true,
});

const About1037 = dynamic(() => import("@/widgets/about/About1037"), {
	ssr: true,
});

const About5005 = dynamic(() => import("@/widgets/about/About5005"), {
	ssr: true,
});

const ProgramCards1038 = dynamic(() => import("@/widgets/exploreonlinecourses/ProgramCards1038"), {
	ssr: true,
});

const KeyNumbers1039 = dynamic(() => import("@/widgets/keynumbers/KeyNumbers1039"), {
	ssr: true,
});

const ProgramBenefits1040 = dynamic(() => import("@/widgets/programBenefits/ProgramBenefits1040"), {
	ssr: true,
});

const Eligibility1041 = dynamic(() => import("@/widgets/eligibility/Eligibility1041"), {
	ssr: true,
});

const ProgramStructure1042 = dynamic(() => import("@/widgets/programstructure/ProgramStructure1042"), {
	ssr: true,
});

const ProgramFee1043 = dynamic(() => import("@/widgets/programfee/ProgramFee1043"), {
	ssr: true,
});

const ProgramBenefits1044 = dynamic(() => import("@/widgets/programBenefits/ProgramBenefits1044"), {
	ssr: true,
});

const ProgramCards1045 = dynamic(() => import("@/widgets/exploreonlinecourses/ProgramCards1045"), {
	ssr: true,
});

const ProgramCards6002 = dynamic(() => import("@/widgets/exploreonlinecourses/ProgramCards6002"), {
	ssr: true,
});

const Placements = dynamic(() => import("@/widgets/placements/Placements"), {
	ssr: true,
});

const Placements2 = dynamic(
	() =>
		import("@/widgets/placements/Placements2").then((mod) => mod.Placements2),
	{
		ssr: true,
	},
);

const Placements3 = dynamic(
	() =>
		import("@/widgets/placements/Placements3").then((mod) => mod.Placements3),
	{
		ssr: true,
	},
);

const Placements4 = dynamic(
	() =>
		import("@/widgets/placements/Placements4").then((mod) => mod.Placements4),
	{
		ssr: true,
	},
);

const MobileApp1 = dynamic(() => import("@/widgets/mobileapp/MobileApp1"), {
	ssr: true,
});

const Masterclass1 = dynamic(
	() => import("@/widgets/onlinemasterclass/OnlineMasterclass1"),
	{
		ssr: true,
	},
);

const Faqs1 = dynamic(() => import("@/widgets/faqs/Faqs1"), {
	ssr: true,
});

const Faqs2 = dynamic(() => import("@/widgets/faqs/Faqs2"), {
	ssr: true,
});

const Visionaries1 = dynamic(() => import("@/widgets/visionaries/Visionaries1"), {
	ssr: true,
});

const LearnFromLeaders = dynamic(() => import("@/widgets/visionaries/LearnFromLeaders"), {
	ssr: true,
});

const LearnFromLeaders1003 = dynamic(() => import("@/widgets/visionaries/LearnFromLeaders1003"), {
	ssr: true,
});

const Faqs3 = dynamic(() => import("@/widgets/faqs/Faqs3"), {
	ssr: true,
});

const Faqs4 = dynamic(() => import("@/widgets/faqs/Faqs4"), {
	ssr: true,
});

const Faculty1 = dynamic(() => import("@/widgets/faculty/Faculty1"), {
	ssr: true,
});

const Faculty2 = dynamic(() => import("@/widgets/faculty/Faculty2"), {
	ssr: true,
});

const Faculty3 = dynamic(() => import("@/widgets/faculty/Faculty3"), {
	ssr: true,
});

const Faculty4 = dynamic(() => import("@/widgets/faculty/Faculty4"), {
	ssr: true,
});
const Faculty5 = dynamic(() => import("@/widgets/faculty/Faculty5"), {
	ssr: true,
});
const Faculty6 = dynamic(() => import("@/widgets/faculty/Faculty6"), {
	ssr: true,
});

const Footer1 = dynamic(() => import("@/widgets/footer/Footer1"), {
	ssr: true,
});

const Footer2 = dynamic(() => import("@/widgets/footer/Footer2"), {
	ssr: true,
});

const Footer3 = dynamic(() => import("@/widgets/footer/Footer3"), {
	ssr: true,
});

const Testimonials1 = dynamic(
	() => import("@/widgets/studenttestimonials/Testimonials1"),
	{
		ssr: true,
	},
);

const Testimonials2 = dynamic(
	() => import("@/widgets/studenttestimonials/Testimonials2"),
	{
		ssr: true,
	},
);

const Recruiters1 = dynamic(() => import("@/widgets/recruiters/Recruiters1"), {
	ssr: true,
});

const AcademicDeliverables1 = dynamic(
	() => import("@/widgets/academicdeliverables/AcademicDeliverables1"),
	{
		ssr: true,
	},
);

const AcademicDeliverables2 = dynamic(
	() => import("@/widgets/academicdeliverables/AcademicDeliverables2"),
	{
		ssr: true,
	},
);

const AcademicDeliverables1001 = dynamic(
	() => import("@/widgets/academicdeliverables/AcademicDeliverables1001"),
	{
		ssr: true,
	},
);

const AcademicDeliverables1002 = dynamic(
	() => import("@/widgets/academicdeliverables/AcademicDeliverables1002"),
	{
		ssr: true,
	},
);

const AcademicDeliverables1006 = dynamic(
	() => import("@/widgets/academicdeliverables/AcademicDeliverables1006"),
	{
		ssr: true,
	},
);

const Subscribe1 = dynamic(() => import("@/widgets/subscribe/Subscribe1"), {
	ssr: true,
});

const ProgramCards1 = dynamic(
	() => import("@/widgets/exploreonlinecourses/ProgramCards1"),
	{
		ssr: true,
	},
);

const ProgramCards2 = dynamic(
	() => import("@/widgets/exploreonlinecourses/ProgramCards2").then((mod) => mod.ProgramCards2),
	{
		ssr: true,
	},
);

const BlogProgramCards1 = dynamic(
	() =>
		import("@/widgets/exploreonlinecourses/BlogProgramCards1").then(
			(mod) => mod.BlogProgramCards1,
		),
	{
		ssr: true,
	},
);

export const Leaddrop1 = dynamic(
	() => import("@/widgets/leaddrop/leaddrop1/index"),

	{
		ssr: true,
	},
);

export const Leaddrop2 = dynamic(
	() => import("@/widgets/leaddrop/leaddrop2/index"),

	{
		ssr: true,
	},
);

export const Leaddrop8 = dynamic(
	() => import("@/widgets/leaddrop/leaddrop8/index"),
	{
		ssr: true,
	},
);

export const Leaddrop9 = dynamic(
	() => import("@/widgets/leaddrop/leaddrop9/index"),
	{
		ssr: true,
	},
);

export const Leaddrop5002 = dynamic(
	() => import("@/widgets/leaddrop/leaddrop5002/index"),
	{
		ssr: true,
	},
);

export const Leaddrop5018 = dynamic(
	() => import("@/widgets/leaddrop/leaddrop5018/index"),
	{
		ssr: true,
	},
);

export const Leaddrop2001 = dynamic(
	() => import("@/widgets/leaddrop/leaddrop2001/index"),
	{
		ssr: true,
	},
);

const ThankYou1 = dynamic(() => import("@/widgets/thankyou/ThankYou1"), {
	ssr: false,
});

const ThankYou1009 = dynamic(() => import("@/widgets/thankyou/ThankYou1009"), {
	ssr: false,
});

const ReferralForm1 = dynamic(
	() => import("@/widgets/referralform/ReferralForm1"),
	{
		ssr: false,
	},
);

const ReferralForm1008 = dynamic(
	() => import("@/widgets/referralform/ReferralForm1008"),
	{
		ssr: false,
	},
);

const ReferralForm1048 = dynamic(
	() => import("@/widgets/referralform/ReferralForm1048"),
	{
		ssr: false,
	},
);

const InfluencerFormWrapper1 = dynamic(
	() => import("@/widgets/influencerform/InfluencerFormWrapper1"),
	{
		ssr: false,
	},
);

const InfluencerFormWrapper1007 = dynamic(
	() => import("@/widgets/influencerform/InfluencerFormWrapper1007"),
	{
		ssr: false,
	},
);

const InfluencerFormWrapper1049 = dynamic(
	() => import("@/widgets/influencerform/InfluencerFormWrapper1049"),
	{
		ssr: false,
	},
);

const GrievanceForm1 = dynamic(
	() => import("@/widgets/grievanceform/GrievanceForm1"),
	{
		ssr: false,
	},
);

const RichTextEditor1 = dynamic(
	() => import("@/widgets/richtexteditor/RichTextEditor1"),
	{
		ssr: true,
	},
);

const RichTextEditor6001 = dynamic(
	() => import("@/widgets/richtexteditor/RichTextEditor6001"),
	{
		ssr: true,
	},
);

const ParaText1 = dynamic(() => import("@/widgets/paratext/ParaText1"), {
	ssr: true,
});

const BlogWithLead1 = dynamic(() => import("@/widgets/blog/BlogWithLead1"), {
	ssr: true,
});

const LatestBlogs1 = dynamic(() => import("@/widgets/latestblogs/LatestBlogs1"), {
	ssr: true,
});

const LatestBlogs2 = dynamic(() => import("@/widgets/latestblogs/LatestBlogs2"), {
	ssr: true,
});

const PopularBlogs1 = dynamic(() => import("@/widgets/popularblogs/PopularBlogs1"), {
	ssr: true,
});

const BlogList1 = dynamic(() => import("@/widgets/bloglist/BlogList1"), {
	ssr: true,
});

const CounselorCallCta1 = dynamic(
	() => import("@/widgets/counselorcallcta/CounselorCallCta1"),
	{ ssr: true },
);

const BreadcrumbBanner1 = dynamic(
	() => import("@/widgets/breadcrumbbanner/BreadcrumbBanner1"),
	{ ssr: true },
);

const BlogInlineImage1 = dynamic(
	() => import("@/widgets/blog/BlogInlineImage1"),
	{ ssr: true },
);

const Header2 = dynamic(() => import("@/widgets/header/Header2"), {
	ssr: true,
});

const Header3 = dynamic(() => import("@/widgets/header/Header3"), {
	ssr: true,
});

const Header4 = dynamic(() => import("@/widgets/header/Header4"), {
	ssr: true,
});

const Header5 = dynamic(() => import("@/widgets/header/Header5"), {
	ssr: true,
});

const Header6 = dynamic(() => import("@/widgets/header/Header6"), {
	ssr: true,
});

const Header7 = dynamic(() => import("@/widgets/header/Header7"), {
	ssr: true,
});

const Header1046 = dynamic(() => import("@/widgets/header/Header1046"), {
	ssr: true,
});

const Header5001 = dynamic(() => import("@/widgets/header/Header5001"), {
	ssr: true,
});

const EligibilityCriteria = dynamic(
	() => import("@/widgets/eligibilitycriteria/EligibilityCriteria1"),
	{
		ssr: true,
	},
);

const Eligibility2 = dynamic(
	() =>
		import("@/widgets/eligibility/Eligibility2").then((m) => m.Eligibility2),
	{ ssr: true },
);

const CareerProspects1 = dynamic(
	() => import("@/widgets/careerprospects/CareerProspects1"),
	{
		ssr: true,
	},
);

const CareerProspects2 = dynamic(
	() => import("@/widgets/careerprospects/CareerProspects2"),
	{
		ssr: true,
	},
);

const CareerProspects3 = dynamic(
	() => import("@/widgets/careerprospects/CareerProspects3"),
	{
		ssr: true,
	},
);

const CareerProspects4 = dynamic(
	() => import("@/widgets/careerprospects/CareerProspects4"),
	{
		ssr: true,
	},
);

const Specialisation1 = dynamic(
	() => import("@/widgets/specialisation/Specialisation1"),
	{
		ssr: true,
	},
);
const Specialisation5017 = dynamic(
	() => import("@/widgets/specialisation/Specialisation5017"),
);

const SuccessStories1 = dynamic(
	() => import("@/widgets/successstories/SuccessStories1"),
	{
		ssr: true,
	},
);

const StudentShowcase = dynamic(
	() => import("@/widgets/successstories/StudentShowcase"),
	{
		ssr: true,
	},
);

const WhatMakesCourseDifferent1 = dynamic(
	() => import("@/widgets/whatmakescoursedifferent/WhatMakesCourseDifferent1"),
	{
		ssr: true,
	},
);

// const WhatMakesCourseDifferent2 = dynamic(
//   () => import("@/widgets/whatmakescoursedifferent/WhatMakesCourseDifferent2"),
//   {
//     ssr: true,
//   },
// );

const Elective1 = dynamic(() => import("@/widgets/elective/Elective1"), {
	ssr: true,
});

const ProgramStructure1 = dynamic(
	() => import("@/widgets/programstructure/ProgramStructure1"),
	{
		ssr: true,
	},
);

const ProgramFee1 = dynamic(() => import("@/widgets/programfee/ProgramFee1"), {
	ssr: true,
});

const ProgramFee2 = dynamic(() => import("@/widgets/programfee/ProgramFee2"), {
	ssr: true,
});

const ProgramFee2Variant3 = dynamic(
	() => import("@/widgets/programfee/ProgramFee2Variant3"),
	{
		ssr: true,
	}
);

const LeaddropForm1 = dynamic(
	() => import("@/widgets/leaddropform/LeaddropForm1"),
	{
		ssr: false,
	},
);

const LeaddropForm2 = dynamic(
	() => import("@/widgets/leaddropform/LeaddropForm2"),
	{
		ssr: false,
	},
);

const MultiStepIntakeForm = dynamic(
	() => import("@/widgets/leaddropform/MultiStepIntakeForm"),
	{ ssr: true },
);

const MultiStepIntakeFormMobileAboutCta = dynamic(
	() =>
		import("@/widgets/leaddropform/MultiStepIntakeForm").then(
			(mod) => mod.MultiStepIntakeFormMobileAboutCta,
		),
	{ ssr: true },
);

const Leaddrop6 = dynamic(() => import("@/widgets/leaddrop/leaddrop6"), {
	ssr: true,
});

const LeaddropForm1MobileAboutCta = dynamic(
	() =>
		import("@/widgets/leaddropform/LeaddropForm1").then(
			(mod) => mod.LeaddropForm1MobileAboutCta,
		),
	{ ssr: false },
);

const LeaddropForm2MobileAboutCta = dynamic(
	() =>
		import("@/widgets/leaddropform/LeaddropForm2").then(
			(mod) => mod.LeaddropForm2MobileAboutCta,
		),
	{ ssr: false },
);

const LeaddropForm10 = dynamic(
	() => import("@/widgets/leaddropform/LeaddropForm10"),
	{
		ssr: true,
	},
);

// Lead Drop Form 3 — inline "Drop a query": saves to the CMS DB only
// (POST /leads/direct), no OTP and no ERP/LSQ push.
const LeaddropForm3 = dynamic(
	() => import("@/widgets/leaddropform/LeaddropForm3"),
	{
		ssr: true,
	},
);

// Lead Drop Form 4 — inline single-step form, no OTP; on submit pushes to CRM
// (POST /leads/sync-drop4). Standalone → ERP; LSQ only for multi-tenant microsites.
const LeaddropForm4 = dynamic(
	() => import("@/widgets/leaddropform/LeaddropForm4"),
	{
		ssr: true,
	},
);

const LeaddropForm10MobileAboutCta = dynamic(
	() =>
		import("@/widgets/leaddropform/LeaddropForm10").then(
			(mod) => mod.LeaddropForm10MobileAboutCta,
		),
	{ ssr: true },
);

const LeaddropForm8 = dynamic(
	() => import("@/widgets/leaddropform/LeaddropForm8"),
	{
		ssr: false,
	},
);

const LeaddropForm8MobileAboutCta = dynamic(
	() =>
		import("@/widgets/leaddropform/LeaddropForm8").then(
			(mod) => mod.LeaddropForm8MobileAboutCta,
		),
	{ ssr: false },
);

// ssr:true so the inline form is server-rendered into the HTML (reserves its
// space, removes the post-hydration chunk-load injection that drove CLS, and
// paints the LCP-area content sooner). Safe because Leaddrop9's only browser
// APIs are effect-guarded and its useSearchParams() call is wrapped in a
// Suspense boundary inside LeaddropForm9.
/**
 * The config-driven custom form. `LeadFormSurface` picks the CMS config when one applies
 * and falls through to the legacy variant otherwise, so it is safe as a registry entry.
 */
const CustomLeadForm = dynamic(
	() => import("@/components/organisms/leadForm/LeadFormSurface"),
	{
		ssr: true,
	},
);

const LeaddropForm9 = dynamic(
	() => import("@/widgets/leaddropform/LeaddropForm9"),
	{
		ssr: true,
	},
);

const LeaddropForm9MobileAboutCta = dynamic(
	() =>
		import("@/widgets/leaddropform/LeaddropForm9").then(
			(mod) => mod.LeaddropForm9MobileAboutCta,
		),
	{ ssr: true },
);

// ssr:true for the same reasons as form 9 — Leaddrop5002's browser APIs are all
// effect-guarded and its useSearchParams() sits inside LeaddropForm5002's Suspense.
const LeaddropForm5002 = dynamic(
	() => import("@/widgets/leaddropform/LeaddropForm5002"),
	{
		ssr: true,
	},
);

const LeaddropForm5002MobileAboutCta = dynamic(
	() =>
		import("@/widgets/leaddropform/LeaddropForm5002").then(
			(mod) => mod.LeaddropForm5002MobileAboutCta,
		),
	{ ssr: true },
);

// ssr:true for the same reasons as form 5002 — Leaddrop5018's browser APIs are all
// effect-guarded and its useSearchParams() sits inside LeaddropForm5018's Suspense.
const LeaddropForm5018 = dynamic(
	() => import("@/widgets/leaddropform/LeaddropForm5018"),
	{
		ssr: true,
	},
);

const LeaddropForm5018MobileAboutCta = dynamic(
	() =>
		import("@/widgets/leaddropform/LeaddropForm5018").then(
			(mod) => mod.LeaddropForm5018MobileAboutCta,
		),
	{ ssr: true },
);

const LeaddropForm2001 = dynamic(
	() => import("@/widgets/leaddropform/LeaddropForm2001"),
	{
		ssr: true,
	},
);

const LeaddropForm2001MobileAboutCta = dynamic(
	() =>
		import("@/widgets/leaddropform/LeaddropForm2001").then(
			(mod) => mod.LeaddropForm2001MobileAboutCta,
		),
	{ ssr: true },
);

const MobileLeadForm1 = dynamic(
	() => import("@/widgets/mobileLeaddropForm/MobileLeadForm1"),
	{
		ssr: false,
	},
);

const MobileLeadForm2 = dynamic(
	() => import("@/widgets/mobileLeaddropForm/MobileLeadForm2"),
	{
		ssr: false,
	},
);

const MobileLeadForm6 = dynamic(
	() => import("@/widgets/mobileLeaddropForm/MobileLeadForm6"),
	{
		ssr: true,
	},
);

const GetFreeCounselling1 = dynamic(
	() => import("@/widgets/getfreecounselling/GetFreeCounselling1"),
	{
		ssr: false,
	},
);

const CourseSpecialisation1 = dynamic(
	() => import("@/widgets/coursespecialisations/CourseSpecialisation1"),
	{
		ssr: true,
	},
);

const ProgramProspects1 = dynamic(
	() => import("@/widgets/programprospects/ProgramProspects1"),
	{
		ssr: true,
	},
);

const ExaminationGuidelines1 = dynamic(
	() => import("@/widgets/examinationguidelines/ExaminationGuidelines1"),
	{
		ssr: true,
	},
);

// const LiveLecture1 = dynamic(
//   () => import("@/widgets/liveLecture/liveLecture1/index"),
//   {
//     ssr: true,
//   },
// );
import LiveLecture1CSR from "@/widgets/liveLecture/liveLecture1/LiveLecture1CSR";

import LiveLecture1011CSR from "@/widgets/liveLecture/liveLecture1011/LiveLecture1011CSR";

import LiveLecture1050CSR from "@/widgets/liveLecture/liveLecture1050/LiveLecture1050CSR";

const ProgramBenefits1 = dynamic(
	() =>
		import("@/widgets/programBenefits/ProgramBenefits1").then(
			(mod) => mod.ProgramBenefits1,
		),
	{
		ssr: true,
	},
);

const ProgramBenefitsGrid2 = dynamic(
	() => import("@/widgets/programBenefits/ProgramBenefitsGrid2"),
	{ ssr: true },
);

const ProgramBenefitsGrid3 = dynamic(
	() => import("@/widgets/programBenefits/ProgramBenefitsGrid3"),
	{ ssr: true },
);

const ProgramBenefitsCourseFee = dynamic(
	() => import("@/widgets/programBenefits/ProgramBenefitsCourseFee"),
	{ ssr: true },
);

const ProgramBenefitsFeePlan = dynamic(
	() => import("@/widgets/programBenefits/ProgramBenefitsFeePlan"),
	{ ssr: true },
);

const ProgramBenefits2 = dynamic(() =>
	import("@/widgets/programBenefits/ProgramBenefits2").then(
		(mod) => mod.ProgramBenefits2,
	),
);

const CaseStudy1 = dynamic(
	() =>
		import("@/widgets/caseStudy/CaseStudy1").then((mod) => mod.CaseStudy1),
	{ ssr: true },
);

const Brand1 = dynamic(
	() => import("@/widgets/brand/Brand1").then((mod) => mod.Brand1),
	{ ssr: true },
);

const Institutes1 = dynamic(
	() => import("@/widgets/institutes/Institutes1").then((mod) => mod.Institutes1),
	{ ssr: true },
);

const ProgramBenefitsPracticalSkills = dynamic(
	() => import("@/widgets/programBenefits/ProgramBenefitsPracticalSkills"),
	{ ssr: true },
);

const ProgramBenefits1005 = dynamic(
	() => import("@/widgets/programBenefits/ProgramBenefits1005"),
	{ ssr: true },
);

// const LearningFromWhere = dynamic();

const CourseOutcome1 = dynamic(
	() =>
		import("@/widgets/courseOutcome/CourseOutcome1").then(
			(mod) => mod.CourseOutcome1,
		),
	{
		ssr: true,
	},
);

const CourseOutcome2 = dynamic(
	() =>
		import("@/widgets/courseOutcome/CourseOutcome2").then(
			(mod) => mod.CourseOutcome2,
		),
	{
		ssr: true,
	},
);

const Certificates1 = dynamic(
	() =>
		import("@/widgets/certificates/Certificates1").then(
			(mod) => mod.Certificates1,
		),
	{ ssr: true },
);

const ProgramStructure2 = dynamic(
	() =>
		import("@/widgets/programstructure/ProgramStructure2").then(
			(mod) => mod.ProgramStructure2,
		),
	{ ssr: true },
);

const ProgramStructure3 = dynamic(
	() => import("@/widgets/programstructure/ProgramStructure3"),
	{ ssr: true },
);

const ProgramStructure4 = dynamic(
	() => import("@/widgets/programstructure/ProgramStructure4"),
	{ ssr: true },
);

const ProgramStructure5 = dynamic(
	() => import("@/widgets/programstructure/ProgramStructure5"),
	{ ssr: true },
);

const Skills1 = dynamic(
	() => import("@/widgets/skills/Skills1").then((mod) => mod.Skills1),
	{ ssr: true },
);

const SkillCards1 = dynamic(
	() => import("@/widgets/skillcards/SkillCards1"),
	{ ssr: true },
);

const Comparison1 = dynamic(
	() => import("@/widgets/comparison/Comparison1").then((mod) => mod.Comparison1),
	{ ssr: true },
);

const Comparison1004 = dynamic(
	() => import("@/widgets/comparison/Comparison1004").then((mod) => mod.Comparison1004),
	{ ssr: true },
);

// const Leaders1 = dynamic(
//   () => import("@/widgets/leaders/Leaders1").then((mod) => mod.Leaders1),
//   { ssr: true }
// );

const ApplicationProcess1 = dynamic(
	() =>
		import("@/widgets/applicationprocess/ApplicationProcess1").then(
			(mod) => mod.default,
		),
	{ ssr: true },
);

const ApplicationProcess2 = dynamic(
	() =>
		import("@/widgets/applicationprocess/ApplicationProcess2").then(
			(mod) => mod.default,
		),
	{ ssr: true },
);

const BannerVideo1 = dynamic(
	() => import("@/widgets/bannerVideo/BannerVideo1"),
	{ ssr: true },
);

const WalkThrough1 = dynamic(
	() => import("@/widgets/walkThrough/WalkThrough1"),
	{ ssr: true },
);

const LifeMilestone1 = dynamic(
	() => import("@/widgets/lifeMilestone/LifeMilestone1"),
	{ ssr: true },
);

const LifeMilestone2 = dynamic(
	() => import("@/widgets/lifeMilestone/LifeMilestone2"),
	{ ssr: true },
);

const LifeMilestone3 = dynamic(
	() => import("@/widgets/lifeMilestone/LifeMilestone3"),
	{ ssr: true },
);

const Enrollments1 = dynamic(
	() => import("@/widgets/enrollments/Enrollments1"),
	{ ssr: true },
);

const Enrollments2 = dynamic(
	() => import("@/widgets/enrollments/Enrollments2"),
	{ ssr: true },
);

const Enrollments3 = dynamic(
	() => import("@/widgets/enrollments/Enrollments3"),
	{ ssr: true },
);

const Enrollments4 = dynamic(
	() => import("@/widgets/enrollments/Enrollments4"),
	{ ssr: true },
);

const Enrollments5 = dynamic(
	() => import("@/widgets/enrollments/Enrollments5"),
	{ ssr: true },
);

const WhoIsThisProgramFor1 = dynamic(
	() => import("@/widgets/whoIsThisProgramFor/WhoIsThisProgramFor1"),
	{ ssr: true },
);

const Leaders1 = dynamic(
	() => import("@/widgets/leaders/Leaders1").then((mod) => mod.Leaders1),
	{ ssr: true },
);

const AuthorProfile1 = dynamic(
	() => import("@/widgets/authorprofile/AuthorProfile1"),
	{
		ssr: true,
	},
);

const AuthorCard1 = dynamic(() => import("@/widgets/authorcard/AuthorCard1"), {
	ssr: true,
});

const AuthorByline1 = dynamic(
	() => import("@/widgets/authorbyline/AuthorByline1"),
	{
		ssr: true,
	},
);

const Heading1 = dynamic(() => import("@/widgets/heading/Heading1"), {
	ssr: true,
});

const PromoPill1 = dynamic(() => import("@/widgets/promoPill/PromoPill1"), {
	ssr: true,
});

const SpecialisationCarousel3000 = dynamic(
	() =>
		import("@/widgets/specialisationCarousel/SpecialisationCarousel3000"),
	{ ssr: true },
);

export const ELIGIBILITY_VARIANTS = {
	ELIGIBILITY_1: "1",
	ELIGIBILITY_2: "2",
	/** BDU Eligibility Criteria — heading + rule + single tinted panel with a leading icon. */
	ELIGIBILITY_1041: "1041",
	/** KUK Eligibility Criteria — heading over one tinted panel with a leading icon. */
	ELIGIBILITY_5012: "5012",
};

export const CAREER_PROSPECTS_VARIANTS = {
	CAREER_PROSPECTS_1: "1",
	CAREER_PROSPECTS_2: "2",
	CAREER_PROSPECTS_3: "3",
	CAREER_PROSPECTS_4: "4",
};

export const SPECIALISATION_VARIANTS = {
	SPECIALISATION_1: "1",
	SPECIALISATION_5017: "5017",
};

export const SUCCESS_STORIES_VARIANTS = {
	SUCCESS_STORIES_1: "1",
	/** Student Showcase (ASU-009): heading + subtitle + paged image-card carousel. */
	SUCCESS_STORIES_2: "2",
};

export const WHAT_MAKES_COURSE_DIFFERENT_VARIANTS = {
	WHAT_MAKES_COURSE_DIFFERENT_1: "1",
	WHAT_MAKES_COURSE_DIFFERENT_2: "2",
};

export const PROGRAM_STRUCTURE_VARIANTS = {
	PROGRAM_STRUCTURE_1: "1",
	PROGRAM_STRUCTURE_2: "2",
	PROGRAM_STRUCTURE_3: "3",
	PROGRAM_STRUCTURE_4: "4",
	PROGRAM_STRUCTURE_5: "5",
	/** BDU Programme Syllabus — semester tabs + subject list on a tinted column, art on the right. */
	PROGRAM_STRUCTURE_1042: "1042",
	/** KUK Programme Structure — brochure CTA beside a semester accordion of subject tables. */
	PROGRAM_STRUCTURE_1064: "1064",
};

export const PROGRAM_FEE_VARIANTS = {
	PROGRAM_FEE_1: "1",
	PROGRAM_FEE_2: "2",
	PROGRAM_FEE_3: "3",
	/** BDU Fee Structure — student-type pills, fee-plan list, line-item table (Program Fee 1 data). */
	PROGRAM_FEE_1043: "1043",
	/** KUK Fee Structure — student-type tabs over plan cards (Program Fee 2 JSON data). */
	PROGRAM_FEE_1066: "1066",
};

export const COURSE_SPECIALISATIONS_VARIANTS = {
	COURSE_SPECIALISATIONS_1: "1",
};

export const PROGRAM_PROSPECTS_VARIANTS = {
	PROGRAM_PROSPECTS_1: "1",
};

export const EXAMINATION_GUIDELINES_VARIANTS = {
	EXAMINATION_GUIDELINES_1: "1",
};

// University constants

export const LEAD_DROP_VARIANTS = {
	LOGIN: "LOGIN",
	DOWNLOAD: "DOWNLOAD",
	REGISTER: "REGISTER",
};

export const UNIVERSITY_SETTINGS_SECTION_TYPES = {
	LEAD_DROP_POPUP: "1",
	LEAD_DROP_FORM: "2",
	COURSES: "3",
};

export const SECTION_TYPES = {
	BANNER: "1",
	HEADER: "2",
	// HEADER_2: "2",
	MENU_ITEMS: "3",
	ABOUT: "4",
	KEY_NUMBERS: "5",
	ACCREDITATION: "6",
	ACADEMIC_DELIVERABLES: "7",
	SCHOLAR: "8",
	RECRUITERS: "9",
	VICE_CHANCELLOR: "10",
	FACULTY: "11",
	TESTIMONIALS: "12",
	MASTERCLASS: "13",
	MESSAGE: "14",
	PLACEMENTS: "15",
	MOBILE_APP: "16",
	FAQ: "17",
	FOOTER: "18",
	SUBSCRIBE: "19",
	PROGRAM_CARDS: "20",
	SPECIALISATION: "21",
	CAREER_PROSPECTS: "22",
	SUCCESS_STORIES: "23",
	WHAT_MAKES_COURSE_DIFFERENT: "24",
	ELIGIBILITY: "25",
	THANK_YOU: "26",
	REFERRAL_FORM: "27",
	INFLUENCER_FORM: "28",
	PROGRAM_STRUCTURE: "29",
	ELECTIVE: "30",
	PROGRAM_FEE: "31",
	RICH_TEXT_EDITOR: "32",
	MOBILE_LEAD_FORM: "33",
	COUNSELING: "34",
	PROGRAM_PROSPECTS: "35",
	COURSE_SPECIALISATIONS: "36",
	EXAMINATION_GUIDELINES: "37",
	LIVE_LECTURE: "38",

	/**
	 * This section gives and shows benefits of the program
	 */
	PROGRAM_BENEFITS: "39",

	//LEARNING_FROM_WHERE: "40",

	COURSE_OUTCOME: "40",

	CERTIFICATES: "41",

	APPLICATION_PROCESS: "42",

	SKILLS: "43",

	WHO_IS_THIS_PROGRAM_FOR: "44",
	BANNER_VIDEO: "45",
	COMPARISON: "46",
	LEADERS: "47",
	DIGITAL_LEARNING: "48",
	VISIONARIES: "49",
	PARA_TEXT: "50",

	/** Virtual campus / walk-through video hero */
	WALK_THROUGH: "62",
	/** Life milestone stepper */
	LIFE_MILESTONE: "63",
	/** Enrollment CTA banner */
	ENROLLMENTS: "64",
	BLOG_WITH_LEAD: "51",
	LATEST_BLOGS: "52",
	COUNSELOR_CALL_CTA: "53",
	BREADCRUMB_BANNER: "54",
	BLOG_LIST: "55",
	BLOG_INLINE_IMAGE: "56",
	POPULAR_BLOGS: "57",
	LEARN_FROM_LEADERS: "58",
	CASE_STUDY: "59",
	BRAND: "60",
	INSTITUTES: "61",
	GRIEVANCE_FORM: "3000",
	/** Configurable heading/title text block. Custom widget id range (3000+). */
	HEADING: "3001",
	/** Author profile: author card + about + their blogs. Custom widget id range (3000+). */
	AUTHOR_PROFILE: "3002",
	/** Author card: compact author bio card. Blog pages with a linked author only. */
	AUTHOR_CARD: "3003",
	/** Author byline: "By <author>" + updated/read-time/views + share. Blog pages with a linked author only. */
	AUTHOR_BYLINE: "3004",
	/** Programme-specialisation card carousel (image cards / icon cards). Custom widget id range (3000+). */
	SPECIALISATION_CAROUSEL: "3005",
	SKILL_CARDS: "3006",
};

export const BANNER_VARIANTS = {
	BANNER_1: "1",
	BANNER_2: "2",
	BANNER_3: "3",
	BANNER_4: "4",
	BANNER_5: "5",
	BANNER_6: "6",
	BANNER_8: "8",
	BANNER_9: "9",
	BANNER_15: "15",
	BANNER_1010: "1010",
	/** Program-page Hero Banner (value-prop column + inline LeadDrop9 form). */
	BANNER_10: "10",
	/** Middle Banner (ASU-010): full-bleed bg image + left image + content + dual CTAs. */
	BANNER_11: "11",
	/** Copy of Banner 1 with a shorter desktop height. Custom widget id range (3000+). */
	BANNER_3000: "3000",
	/** KUK auxiliary page hero — background image + white scrim + centred title and icon links. */
	BANNER_3001: "3001",
	/** KUK marketing banner — full-bleed CTA band (heading + line + button) over a background photo. */
	BANNER_5004: "5004",
	/** BDU Hero — full-bleed slide carousel + left gradient overlay card + accreditation bar. */
	BANNER_1025: "1025",
	/** BDU Programme Hero — Banner 1025 layout with an h2 sub-heading and Apply + Brochure CTAs. */
	BANNER_1035: "1035",
	/** BDU auxiliary page hero — static image + left gradient card + accreditation bar. Pairs with Rich Text Editor 6001. */
	BANNER_6000: "6000",
	/** KUK home hero — slide carousel behind a white card (Welcome to / name / Online / CTA). */
	BANNER_1051: "1051",
	/** KUK home "Want to set yourself apart" band — photo + scrim + icon + heading + outline CTA. */
	BANNER_1058: "1058",
	/** KUK home referral band — artwork background, highlighted heading, gradient pill CTA. */
	BANNER_1059: "1059",
	/** KUK programme hero — three-slide carousel, each slide its own layout, plus an accreditation rail. */
	BANNER_1061: "1061",
	/** KUK referral band + USP strip — Banner 1059's band with a three-column USP row under it. */
	BANNER_1062: "1062",
	/** KUK launchpad access band — artwork background, gift icon, heading and an outline CTA. */
	BANNER_1068: "1068",
};

export const HEADER_VARIANTS = {
	HEADER_1: "1",
	HEADER_2: "2",
	HEADER_3: "3",
	HEADER_4: "4",
	HEADER_5: "5",
	HEADER_6: "6",
	HEADER_7: "7",
	/** BDU contact strip — right-aligned phone + WhatsApp pills on a solid bar, desktop only. */
	HEADER_1046: "1046",
	/** Promotional pill ("Admissions closing soon"), optionally pinned over the page. */
	PROMO_PILL: "5000",
	/** BDU site header — logo + phone line + WhatsApp button + Apply CTA. */
	HEADER_5001: "5001",
	/** KUK landing-page site header — logo, WhatsApp link, phone line, Apply CTA. */
	HEADER_5015: "5015",
	/** KUK promotional marquee — one line of promo copy scrolling on a tinted bar. */
	HEADER_5016: "5016",
};

export const ABOUT_VARIANTS = {
	ABOUT_1: "1",
	ABOUT_2: "2",
	ABOUT_3: "3",
	ABOUT_4: "4",
	ABOUT_5: "5",
	/** BDU About Us — square image + gradient rule + Know More link. */
	ABOUT_1028: "1028",
	/** BDU About the programme — heading + rule + justified copy + keypoint chips + inline lead form. */
	ABOUT_1037: "1037",
	/** KUK About the programme — heading, intro copy and key-content cards (scroll rail from 768px, accordion below). */
	ABOUT_5005: "5005",
	/** KUK home About Us — YouTube facade beside justified copy and a Know More CTA. */
	ABOUT_1054: "1054",
	/** KUK home Vice Chancellor's message — portrait card beside vision / mission cards. */
	ABOUT_1057: "1057",
};

export const ACCREDITATION_VARIANTS = {
	ACCREDITATION_1: "1",
	ACCREDITATION_2: "2",
	ACCREDITATION_3: "3",
	ACCREDITATION_4: "4",
	ACCREDITATION_5: "5",
	ACCREDITATION_1000: "1000",
	/** KUK home accreditation strip — badge over a label, hairline rules between. */
	ACCREDITATION_1052: "1052",
};

export const KEY_NUMBERS_VARIANTS = {
	KEY_NUMBERS_1: "1",
	KEY_NUMBERS_2: "2",
	/** BDU Stats — circled icon + count + label on a solid bar. */
	KEY_NUMBERS_1026: "1026",
	/** BDU Programme key features — circled icon + single line of copy on a solid bar. */
	KEY_NUMBERS_1036: "1036",
	/** BDU Programme key content — big number + label on a solid bar, hairline separators. */
	KEY_NUMBERS_1039: "1039",
	/** KUK programme key features — icon over one line of copy on a tinted strip. */
	KEY_NUMBERS_5006: "5006",
	/** KUK learning highlights — big figure over its label on a gradient band. */
	KEY_NUMBERS_5007: "5007",
	/** KUK home Stats — icon over a formatted count and its label on a gradient bar. */
	KEY_NUMBERS_1055: "1055",
};

export const DIGITAL_LEARNING_VARIANTS = {
	DIGITAL_LEARNING_1: "1",
};

export const VISIONARIES_VARIANTS = {
	VISIONARIES_1: "1",
};

export const LEARN_FROM_LEADERS_VARIANTS = {
	LEARN_FROM_LEADERS_1: "1",
	LEARN_FROM_LEADERS_1003: "1003",
};

export const PARA_TEXT_VARIANTS = {
	PARA_TEXT_1: "1",
};

export const RECRUITERS_VARIANTS = {
	RECRUITERS_1: "1",
	/** KUK Where our graduates work — heading, sub-heading and a row of employer logos. */
	RECRUITERS_5010: "5010",
};

export const LEARNERS_VARIANTS = {
	LEARNERS_1: "1",
};

export const SCHOLAR_VARIANTS = {
	SCHOLAR_1: "1",
};

export const ACADEMIC_DELIVERABLES_VARIANTS = {
	ACADEMIC_DELIVERABLES_1: "1",
	ACADEMIC_DELIVERABLES_2: "2",
	ACADEMIC_DELIVERABLES_1001: "1001",
	ACADEMIC_DELIVERABLES_1002: "1002",
	ACADEMIC_DELIVERABLES_1006: "1006",
	/** BDU Hands-On Learning — tinted bg image + numbered icon rows. */
	ACADEMIC_DELIVERABLES_1031: "1031",
};

export const VICE_CHANCELLOR_VARIANTS = {
	VICE_CHANCELLOR_1: "1",
};

export const FACULTY_VARIANTS = {
	FACULTY_1: "1",
	FACULTY_2: "2",
	FACULTY_3: "3",
	FACULTY_4: "4",
	FACULTY_5: "5",
	FACULTY_6: "6",
};

export const TESTIMONIAL_VARIANTS = {
	TESTIMONIAL_1: "1",
};

export const MASTERCLASS_VARIANTS = {
	MASTERCLASS_1: "1",
};

export const MESSAGE_VARIANTS = {
	MESSAGE_1: "1",
};

export const PLACEMENTS_VARIANTS = {
	PLACEMENTS_1: "1",
	PLACEMENTS_2: "2",
	PLACEMENTS_3: "3",
	PLACEMENTS_4: "4",
};

export const MOBILE_APP_VARIANTS = {
	MOBILE_APP_1: "1",
};

export const Testimonials_VARIANTS = {
	Testimonials_1: "1",
	Testimonials_2: "2",
	/** KUK home student testimonials — scroll rail of portrait quote cards with dim-when-offscreen. */
	Testimonials_1056: "1056",
};
export const FOOTER_VARIANTS = {
	FOOTER_1: "1",
	FOOTER_2: "2",
	FOOTER_3: "3",
	/** BDU Footer — bg image, link columns, disclaimer + copyright. */
	FOOTER_1034: "1034",
	/** KUK Footer — solid band with optional link columns and a copyright bar. */
	FOOTER_5014: "5014",
};

export const PROGRAM_CARDS_VARIANTS = {
	PROGRAM_CARDS_1: "1",
	PROGRAM_CARDS_2: "2",
	PROGRAM_CARDS_3: "3",
	PROGRAM_CARDS_4: "4",
	/** Blog: Program Cards 1 layout in the article column (metadata / ExploreCourses) */
	PROGRAM_CARDS_BLOG_1: "5",
	/** BDU Featured Programmes — Bachelors/Masters tabs + image cards. */
	PROGRAM_CARDS_1027: "1027",
	/** BDU Specialisations — heading + rule + wrapping grid of tinted programme cards. */
	PROGRAM_CARDS_1038: "1038",
	/** BDU Other Specialisations — left-aligned heading + horizontal card rail. */
	PROGRAM_CARDS_1045: "1045",
	/** BDU auxiliary page "Explore Our Programs" — tinted band + card rail. Closes the Banner 6000 / RTE 6001 stack. */
	PROGRAM_CARDS_6002: "6002",
	/** KUK home Featured Programmes — level tabs, programme rail, detail card, specialisation grid. */
	PROGRAM_CARDS_1053: "1053",
	/** KUK Explore other Specialisations — eyebrow heading beside a row of specialisation cards. */
	PROGRAM_CARDS_1067: "1067",
	/** KUK Explore other courses — artwork band, four-up card grid on desktop, rail below. */
	PROGRAM_CARDS_1070: "1070",
};
export const THANK_YOU_VARIANTS = {
	THANK_YOU_1: "1",
	/** CU-styled standalone thank-you screen (refurl / influencer landing) */
	THANK_YOU_1009: "1009",
};

export const REFERRAL_FORM_VARIANTS = {
	REFERRAL_FORM_1: "1",
	REFERRAL_FORM_1008: "1008",
	/** BDU-styled referral (refurl) form */
	REFERRAL_FORM_1048: "1048",
};

export const INFLUENCER_FORM_VARIANTS = {
	INFLUENCER_FORM_1: "1",
	INFLUENCER_FORM_1007: "1007",
	/** BDU-styled influencer form */
	INFLUENCER_FORM_1049: "1049",
};

export const GRIEVANCE_FORM_VARIANTS = {
	GRIEVANCE_FORM_1: "3000",
};

export const RICH_TEXT_EDITOR_VARIANTS = {
	RICH_TEXT_EDITOR_1: "1",
	/** BDU auxiliary page body — article column + 328px lead form rail. Pairs with Banner 6000. */
	RICH_TEXT_EDITOR_6001: "6001",
};

export const BLOG_WITH_LEAD_VARIANTS = {
	BLOG_WITH_LEAD_1: "1",
};

export const LATEST_BLOGS_VARIANTS = {
	LATEST_BLOGS_1: "1",
	LATEST_BLOGS_2: "2",
};

export const POPULAR_BLOGS_VARIANTS = {
	POPULAR_BLOGS_1: "1",
};

export const COUNSELOR_CALL_CTA_VARIANTS = {
	COUNSELOR_CALL_CTA_1: "1",
};

export const BREADCRUMB_BANNER_VARIANTS = {
	BREADCRUMB_BANNER_1: "1",
};

export const BLOG_LIST_VARIANTS = {
	BLOG_LIST_1: "1",
};

export const BLOG_INLINE_IMAGE_VARIANTS = {
	BLOG_INLINE_IMAGE_1: "1",
};

export const FAQ_VARIANTS = {
	FAQ_1: "1",
	FAQ_2: "2",
	FAQ_3: "3",
	FAQ_4: "4",
	/** BDU FAQs — numbered accordion with tinted open state + Contact Us CTA. */
	FAQ_1033: "1033",
	/** KUK FAQs — single-open accordion under a ruled heading, with a Contact Us CTA. */
	FAQ_5013: "5013",
};

export const MENU_ITEMS_VARIANTS = {
	MENU_ITEMS_1: "1",
	MENU_ITEMS_2: "2",
	MENU_ITEMS_3: "3",
	MENU_ITEMS_4: "4",
	MENU_ITEMS_5: "5",
	MENU_ITEMS_2000: "2000",
	/** BDU nav: white bar, logo + links with 3-level dropdowns + gradient Apply CTA. */
	MENU_ITEMS_1047: "1047",
	/** KUK site nav: white bar, logo + links with programme mega-menu + Apply CTA. */
	MENU_ITEMS_1060: "1060",
};

export const SUBSCRIBE_VARIANTS = {
	SUBSCRIBE_1: "1",
};

export const LEAD_DROP_POPUP_VARIANTS = {
	LEAD_DROP_POPUP_1: "1",
	LEAD_DROP_POPUP_2: "2",
	// 3 = DB-only "Drop a query" (no OTP/CRM); 4 = no-OTP → CRM (ERP always, LSQ multi-tenant only).
	LEAD_DROP_POPUP_3: "3",
	LEAD_DROP_POPUP_4: "4",
	LEAD_DROP_POPUP_7: "7",
	LEAD_DROP_POPUP_10: "10",
	LEAD_DROP_POPUP_6: "6",
	LEAD_DROP_POPUP_8: "8",
	LEAD_DROP_POPUP_9: "9",
	// 2001 = single-step popup, OTP revealed inline on a valid phone.
	// Certification courses continue to a background step + LMS signup.
	LEAD_DROP_POPUP_2001: "2001",
	// 11 = BDU-style single-step popup with the OTP revealed inline.
	LEAD_DROP_POPUP_5002: "5002",
	// 5018 = KUK phone-first popup: phone alone, then the rest revealed for a new
	// lead, then a separate OTP screen.
	LEAD_DROP_POPUP_5018: "5018",
};

export const LEAD_DROP_FORM_VARIANTS = {
	LEAD_DROP_FORM_1: "1",
	LEAD_DROP_FORM_2: "2",
	// 3 = DB-only "Drop a query" (no OTP/CRM); 4 = no-OTP → CRM (ERP always, LSQ multi-tenant only).
	LEAD_DROP_FORM_3: "3",
	LEAD_DROP_FORM_4: "4",
	LEAD_DROP_FORM_10: "10",
	LEAD_DROP_FORM_6: "6",
	LEAD_DROP_FORM_8: "8",
	LEAD_DROP_FORM_9: "9",
	// 2001 = inline twin of popup 2001 (same card, no close button).
	LEAD_DROP_FORM_2001: "2001",
	// 11 = inline twin of popup 5002 (BDU-style single-step + inline OTP).
	LEAD_DROP_FORM_5002: "5002",
	/**
	 * The CMS-authored custom form (field schema × skin), not a hand-built design.
	 *
	 * Registered as a variant so every host widget renders it with NO change: they all do
	 * `LEAD_DROP_FORM_SECTION_VARIANTS[variant]` and then gate their lead column on that
	 * component existing. The store derives this id whenever a renderable inline config
	 * applies to the page — see store/slices/leaddropform.ts and constants/leadFormSurface.ts.
	 */
	CUSTOM_FORM: "3005",
	// 5018 = inline twin of popup 5018 (KUK phone-first + separate OTP screen).
	LEAD_DROP_FORM_5018: "5018",
};

export const COURSES_VARIANTS = {
	COURSES_1: "1",
};

export const ELECTIVE_VARIANTS = {
	ELECTIVE_1: "1",
	/** KUK Electives — elective tabs down the left, a subject/semester table on the right. */
	ELECTIVE_1065: "1065",
};

export const MOBILE_LEAD_FORM_VARIANTS = {
	MOBILE_LEAD_FORM_1: "1",
	MOBILE_LEAD_FORM_2: "2",
	MOBILE_LEAD_FORM_6: "6",
};

export const COUNSELING_VARIANTS = {
	COUNSELING_1: "1",
};

export const LIVE_LECTURE_VARIANTS = {
	LIVE_LECTURE_1: "1",
	LIVE_LECTURE_1011: "1011",
	LIVE_LECTURE_1050: "1050",
};

/** Must match `webapp/src/constants/admin/sectionTypes.ts` and server `PROGRAM_BENEFITS_VARIANTS`. */
export const PROGRAM_BENEFITS_VARIANTS = {
	PROGRAM_BENEFITS_1: "1",
	PROGRAM_BENEFITS_2: "2",
	PROGRAM_BENEFITS_3: "3",
	PROGRAM_BENEFITS_4: "4",
	PROGRAM_BENEFITS_5: "5",
	PROGRAM_BENEFITS_6: "6",
	PROGRAM_BENEFITS_7: "7",
	/**
	 * Degree grid — Figma "Degree that moves with you": a 3x2 icon-card grid.
	 *
	 * Lived at "2" until the unified-tenancy merge repointed "2" at the Program
	 * Benefits 2 CAROUSEL, which renders from a different column set entirely
	 * (`description` / `left_navigation_icon` / `enable_stack_carousel`, where the
	 * grid fills `subtitle` / `section_background_image`). Moving the grid to an
	 * uncontested id ends that collision for good instead of re-fighting it on
	 * every merge. Its fields still live in `programBenefits_12.ts` and its rows in
	 * the `program_benefits_12` slice — only the id changed.
	 */
	PROGRAM_BENEFITS_3000: "3000",
	PROGRAM_BENEFITS_1005: "1005",
	/** BDU Key Benefits — tinted bg image + icon/title/description cards. */
	PROGRAM_BENEFITS_1029: "1029",
	/** BDU Programme Roadmap / Key Programme Features — bg art + icon/title/description columns. */
	PROGRAM_BENEFITS_1040: "1040",
	/** BDU Learn More — heading + rule + rich-text cards with a Read more clamp. */
	PROGRAM_BENEFITS_1044: "1044",
	/** KUK Why-KUK-Online cards — washed-out photo behind an icon, title and copy. */
	PROGRAM_BENEFITS_5008: "5008",
	/** KUK Career Roadmap — icon/role/description cards plus a counsellor CTA. */
	PROGRAM_BENEFITS_5009: "5009",
	/** KUK "Why Choose Us?" — icon/title/description cards as a rail above 768px, a two-column grid below. */
	PROGRAM_BENEFITS_1063: "1063",
	/** KUK Learn More — tinted band of rich-text cards with a View more clamp. */
	PROGRAM_BENEFITS_1069: "1069",
};

export const COURSE_OUTCOME_VARIANTS = {
	COURSE_OUTCOME_1: "1",
	COURSE_OUTCOME_2: "2",
};

export const APPLICATION_PROCESS_VARIANTS = {
	APPLICATION_PROCESS_1: "1",
	APPLICATION_PROCESS_2: "2",
	/** BDU Admission Process — numbered step cards. */
	APPLICATION_PROCESS_1030: "1030",
	/** KUK Admission Process — numbered steps beside the inline lead form. */
	APPLICATION_PROCESS_5011: "5011",
};

export const CERTIFICATES_VARIANTS = {
	/**
	 * it is a certificate carousal with a title and subtitle.
	 */
	CERTIFICATES_1: "1",
};

export const SKILLS_VARIANTS = {
	SKILLS_1: "1",
};

export const WHO_IS_THIS_PROGRAM_FOR_VARIANTS = {
	WHO_IS_THIS_PROGRAM_FOR_1: "1",
};

export const BANNER_VIDEO_VARIANTS = {
	BANNER_VIDEO_1: "1",
};

export const WALK_THROUGH_VARIANTS = {
	WALK_THROUGH_1: "1",
};

export const LIFE_MILESTONE_VARIANTS = {
	LIFE_MILESTONE_1: "1",
	LIFE_MILESTONE_2: "2",
	LIFE_MILESTONE_3: "3",
};

export const ENROLLMENTS_VARIANTS = {
	ENROLLMENTS_1: "1",
	ENROLLMENTS_2: "2",
	ENROLLMENTS_3: "3",
	ENROLLMENTS_4: "4",
	ENROLLMENTS_5: "5",
};

export const COMPARISON_VARIANTS = {
	COMPARISON_1: "1",
	COMPARISON_1004: "1004",
};

export const LEADERS_VARIANTS = {
	LEADERS_1: "1",
	/** BDU Leadership — bordered portrait cards in a scroll rail. */
	LEADERS_1032: "1032",
};

export const CASE_STUDY_VARIANTS = {
	CASE_STUDY_1: "1",
};

export const BRAND_VARIANTS = {
	BRAND_1: "1",
};

export const INSTITUTES_VARIANTS = {
	INSTITUTES_1: "1",
};

export const HEADING_VARIANTS = {
	HEADING_1: "3000",
};

export const AUTHOR_PROFILE_VARIANTS = {
	AUTHOR_PROFILE_1: "3000",
};

export const AUTHOR_CARD_VARIANTS = {
	AUTHOR_CARD_1: "3000",
};

export const AUTHOR_BYLINE_VARIANTS = {
	AUTHOR_BYLINE_1: "3000",
};

export const SPECIALISATION_CAROUSEL_VARIANTS = {
	SPECIALISATION_CAROUSEL_1: "3000",
};

export const SKILL_CARDS_VARIANTS = {
	SKILL_CARDS_1: "3000",
};


export const SECTION_VARIANTS = {
	[SECTION_TYPES.BANNER]: {
		[BANNER_VARIANTS.BANNER_1]: (props) => <Banner1 {...props} />,
		[BANNER_VARIANTS.BANNER_2]: (props) => <Banner2 {...props} />,
		[BANNER_VARIANTS.BANNER_3]: (props) => <Banner3 {...props} />,
		[BANNER_VARIANTS.BANNER_4]: (props) => <HeroCarousel {...props} />,
		[BANNER_VARIANTS.BANNER_5]: (props) => <BannerFeatureGrid {...props} />,
		[BANNER_VARIANTS.BANNER_6]: (props) => <Banner5 {...props} />,
		[BANNER_VARIANTS.BANNER_8]: (props) => <Banner8 {...props} />,
		[BANNER_VARIANTS.BANNER_9]: (props) => <Banner9 {...props} />,
		[BANNER_VARIANTS.BANNER_15]: (props) => <Banner15 {...props} />,
		[BANNER_VARIANTS.BANNER_10]: (props) => <Banner10 {...props} />,
		[BANNER_VARIANTS.BANNER_11]: (props) => <Banner11 {...props} />,
		[BANNER_VARIANTS.BANNER_1010]: (props) => <Banner1010 {...props} />,
		[BANNER_VARIANTS.BANNER_3000]: (props) => <Banner3000 {...props} />,
		[BANNER_VARIANTS.BANNER_1025]: (props) => <Banner1025 {...props} />,
		[BANNER_VARIANTS.BANNER_1035]: (props) => <Banner1035 {...props} />,
		[BANNER_VARIANTS.BANNER_3001]: (props) => <Banner3001 {...props} />,
		[BANNER_VARIANTS.BANNER_5004]: (props) => <Banner5004 {...props} />,
		[BANNER_VARIANTS.BANNER_1051]: (props) => <Banner1051 {...props} />,
		[BANNER_VARIANTS.BANNER_1058]: (props) => <Banner1058 {...props} />,
		[BANNER_VARIANTS.BANNER_1059]: (props) => <Banner1059 {...props} />,
		[BANNER_VARIANTS.BANNER_1061]: (props) => <Banner1061 {...props} />,
		[BANNER_VARIANTS.BANNER_1062]: (props) => <Banner1062 {...props} />,
		[BANNER_VARIANTS.BANNER_1068]: (props) => <Banner1068 {...props} />,
		[BANNER_VARIANTS.BANNER_6000]: (props) => <Banner6000 {...props} />,
	},
	[SECTION_TYPES.HEADER]: {
		[HEADER_VARIANTS.HEADER_1]: (data) => <Header1 data={data} />,
		[HEADER_VARIANTS.HEADER_2]: (data) => <Header2 data={data} />,
		[HEADER_VARIANTS.HEADER_3]: (data) => <Header3 data={data} />,
		[HEADER_VARIANTS.HEADER_4]: (data) => <Header4 data={data} />,
		[HEADER_VARIANTS.HEADER_5]: (data) => <Header5 data={data} />,
		[HEADER_VARIANTS.HEADER_6]: (data) => <Header6 data={data} />,
		[HEADER_VARIANTS.HEADER_7]: (data) => <Header7 data={data} />,
		[HEADER_VARIANTS.HEADER_1046]: (data) => <Header1046 data={data} />,
		[HEADER_VARIANTS.HEADER_5001]: (data) => <Header5001 data={data} />,
		[HEADER_VARIANTS.PROMO_PILL]: (data) => <PromoPill1 data={data} />,
		[HEADER_VARIANTS.HEADER_5015]: (data) => <Header5015 data={data} />,
		[HEADER_VARIANTS.HEADER_5016]: (data) => <Header5016 data={data} />,
	},
	[SECTION_TYPES.ABOUT]: {
		[ABOUT_VARIANTS.ABOUT_1]: (data) => <About1 data={data} />,
		[ABOUT_VARIANTS.ABOUT_2]: (data) => <About2 data={data} />,
		[ABOUT_VARIANTS.ABOUT_5]: (data) => <InstituteSection data={data} />,
		[ABOUT_VARIANTS.ABOUT_4]: (data) => <AboutMegaFooter data={data} />,
		[ABOUT_VARIANTS.ABOUT_3]: (data) => <About3 data={data} />,
		[ABOUT_VARIANTS.ABOUT_1028]: (data) => (
			<About1028 data={data} />
		),
		[ABOUT_VARIANTS.ABOUT_1037]: (data) => <About1037 data={data} />,
		[ABOUT_VARIANTS.ABOUT_5005]: (data) => <About5005 data={data} />,
		[ABOUT_VARIANTS.ABOUT_1054]: (data) => <About1054 data={data} />,
		[ABOUT_VARIANTS.ABOUT_1057]: (data) => <About1057 data={data} />,
	},
	[SECTION_TYPES.ACCREDITATION]: {
		[ACCREDITATION_VARIANTS.ACCREDITATION_1052]: (data) => (
			<Accreditation1052 data={data} />
		),
		[ACCREDITATION_VARIANTS.ACCREDITATION_1]: (data) => (
			<Accreditation1 data={data} />
		),
		[ACCREDITATION_VARIANTS.ACCREDITATION_2]: (data) => (
			<Accreditation2 data={data} />
		),
		[ACCREDITATION_VARIANTS.ACCREDITATION_3]: (data) => (
			<Accreditation3 data={data} />
		),
		[ACCREDITATION_VARIANTS.ACCREDITATION_4]: (data) => (
			<Accreditation4 data={data} />
		),
		[ACCREDITATION_VARIANTS.ACCREDITATION_5]: (data) => (
			<Accreditation5 data={data} />
		),
		[ACCREDITATION_VARIANTS.ACCREDITATION_1000]: (data) => (
			<Accreditation1000 data={data} />
		),
	},
	[SECTION_TYPES.KEY_NUMBERS]: {
		[KEY_NUMBERS_VARIANTS.KEY_NUMBERS_1]: (data) => <KeyNumbers1 data={data} />,
		[KEY_NUMBERS_VARIANTS.KEY_NUMBERS_2]: (data) => <KeyNumbers2 data={data} />,
		[KEY_NUMBERS_VARIANTS.KEY_NUMBERS_1026]: (data) => (
			<KeyNumbers1026 data={data} />
		),
		[KEY_NUMBERS_VARIANTS.KEY_NUMBERS_1036]: (data) => (
			<KeyNumbers1036 data={data} />
		),
		[KEY_NUMBERS_VARIANTS.KEY_NUMBERS_1039]: (data) => (
			<KeyNumbers1039 data={data} />
		),
		[KEY_NUMBERS_VARIANTS.KEY_NUMBERS_5006]: (data) => <KeyNumbers5006 data={data} />,
		[KEY_NUMBERS_VARIANTS.KEY_NUMBERS_5007]: (data) => <KeyNumbers5007 data={data} />,
		[KEY_NUMBERS_VARIANTS.KEY_NUMBERS_1055]: (data) => <KeyNumbers1055 data={data} />,
	},
	[SECTION_TYPES.DIGITAL_LEARNING]: {
		[DIGITAL_LEARNING_VARIANTS.DIGITAL_LEARNING_1]: (data) => (
			<DigitalLearning1 data={data} />
		),
	},
	[SECTION_TYPES.VISIONARIES]: {
		[VISIONARIES_VARIANTS.VISIONARIES_1]: (data) => (
			<Visionaries1 data={data} />
		),
	},
	[SECTION_TYPES.LEARN_FROM_LEADERS]: {
		[LEARN_FROM_LEADERS_VARIANTS.LEARN_FROM_LEADERS_1]: (data) => (
			<LearnFromLeaders data={data} />
		),
		[LEARN_FROM_LEADERS_VARIANTS.LEARN_FROM_LEADERS_1003]: (data) => (
			<LearnFromLeaders1003 data={data} />
		),
	},
	[SECTION_TYPES.RECRUITERS]: {
		[RECRUITERS_VARIANTS.RECRUITERS_1]: (data) => <Recruiters1 data={data} />,
		[RECRUITERS_VARIANTS.RECRUITERS_5010]: (data) => <Recruiters5010 data={data} />,
	},
	// [SECTION_TYPES.LEARNERS]: {
	//   [LEARNERS_VARIANTS.LEARNERS_1]: (data) => <Learners1 data={data} />,
	// },
	[SECTION_TYPES.SCHOLAR]: {
		[SCHOLAR_VARIANTS.SCHOLAR_1]: (data) => <Scholar1 data={data} />,
	},
	[SECTION_TYPES.ACADEMIC_DELIVERABLES]: {
		[ACADEMIC_DELIVERABLES_VARIANTS.ACADEMIC_DELIVERABLES_1]: (data) => (
			<AcademicDeliverables1 data={data} />
		),
		[ACADEMIC_DELIVERABLES_VARIANTS.ACADEMIC_DELIVERABLES_2]: (data) => (
			<AcademicDeliverables2 data={data} />
		),
		[ACADEMIC_DELIVERABLES_VARIANTS.ACADEMIC_DELIVERABLES_1001]: (data) => (
			<AcademicDeliverables1001 data={data} />
		),
		[ACADEMIC_DELIVERABLES_VARIANTS.ACADEMIC_DELIVERABLES_1002]: (data) => (
			<AcademicDeliverables1002 data={data} />
		),
		[ACADEMIC_DELIVERABLES_VARIANTS.ACADEMIC_DELIVERABLES_1006]: (data) => (
			<AcademicDeliverables1006 data={data} />
		),
		[ACADEMIC_DELIVERABLES_VARIANTS.ACADEMIC_DELIVERABLES_1031]: (data) => (
			<AcademicDeliverables1031 data={data} />
		),
	},
	// [SECTION_TYPES.VICE_CHANCELLOR]: {
	//   [VICE_CHANCELLOR_VARIANTS.VICE_CHANCELLOR_1]: (data) => (
	//     <ViceChancellor1 data={data} />
	//   ),
	// },
	[SECTION_TYPES.FACULTY]: {
		[FACULTY_VARIANTS.FACULTY_1]: (data) => <Faculty1 data={data} />,
		[FACULTY_VARIANTS.FACULTY_2]: (data) => <Faculty2 data={data} />,
		[FACULTY_VARIANTS.FACULTY_3]: (data) => <Faculty3 data={data} />,
		[FACULTY_VARIANTS.FACULTY_4]: (data) => <Faculty4 data={data} />,
		[FACULTY_VARIANTS.FACULTY_5]: (data) => <Faculty5 data={data} />,
		[FACULTY_VARIANTS.FACULTY_6]: (data) => <Faculty6 data={data} />,
	},
	[SECTION_TYPES.TESTIMONIALS]: {
		[Testimonials_VARIANTS.Testimonials_1]: (data) => (
			<Testimonials1 data={data} />
		),
		[Testimonials_VARIANTS.Testimonials_2]: (data) => (
			<Testimonials2 data={data} />
		),
		[Testimonials_VARIANTS.Testimonials_1056]: (data) => (
			<Testimonials1056 data={data} />
		),
	},
	[SECTION_TYPES.MASTERCLASS]: {
		[MASTERCLASS_VARIANTS.MASTERCLASS_1]: (data) => (
			<Masterclass1 data={data} />
		),
	},
	[SECTION_TYPES.MESSAGE]: {
		[MESSAGE_VARIANTS.MESSAGE_1]: (data) => <About1 data={data} />,
	},
	[SECTION_TYPES.FOOTER]: {
		[FOOTER_VARIANTS.FOOTER_1]: (data) => <Footer1 data={data} />,
		[FOOTER_VARIANTS.FOOTER_2]: (data) => <Footer2 data={data} />,
		[FOOTER_VARIANTS.FOOTER_3]: (data) => <Footer3 data={data} />,
		[FOOTER_VARIANTS.FOOTER_1034]: (data) => (
			<Footer1034 data={data} />
		),
		[FOOTER_VARIANTS.FOOTER_5014]: (data) => <Footer5014 data={data} />,
	},
	[SECTION_TYPES.FAQ]: {
		[FAQ_VARIANTS.FAQ_1]: (data) => <Faqs1 data={data} />,
		[FAQ_VARIANTS.FAQ_2]: (data) => <Faqs2 data={data} />,
		[FAQ_VARIANTS.FAQ_3]: (data) => <Faqs3 data={data} />,
		[FAQ_VARIANTS.FAQ_4]: (data) => <Faqs4 data={data} />,
		[FAQ_VARIANTS.FAQ_1033]: (data) => (
			<Faqs1033 data={data} />
		),
		[FAQ_VARIANTS.FAQ_5013]: (data) => <Faqs5013 data={data} />,
	},
	[SECTION_TYPES.PLACEMENTS]: {
		[PLACEMENTS_VARIANTS.PLACEMENTS_1]: (data) => <Placements data={data} />,
		[PLACEMENTS_VARIANTS.PLACEMENTS_2]: (data) => <Placements2 data={data} />,
		[PLACEMENTS_VARIANTS.PLACEMENTS_3]: (data) => <Placements3 data={data} />,
		[PLACEMENTS_VARIANTS.PLACEMENTS_4]: (data) => <Placements4 data={data} />,
	},
	[SECTION_TYPES.MOBILE_APP]: {
		[MOBILE_APP_VARIANTS.MOBILE_APP_1]: (data) => <MobileApp1 data={data} />,
	},
	[SECTION_TYPES.MENU_ITEMS]: {
		[MENU_ITEMS_VARIANTS.MENU_ITEMS_1]: (data) => <NavBar data={data} />,
		[MENU_ITEMS_VARIANTS.MENU_ITEMS_2]: (data) => <NavBar2 data={data} />,
		[MENU_ITEMS_VARIANTS.MENU_ITEMS_3]: (data) => <NavBar3 data={data} />,
		[MENU_ITEMS_VARIANTS.MENU_ITEMS_4]: (data) => <NavBar4 data={data} />,
		[MENU_ITEMS_VARIANTS.MENU_ITEMS_5]: (data) => <NavBar5 data={data} />,
		[MENU_ITEMS_VARIANTS.MENU_ITEMS_2000]: (data) => <NavBar2000 data={data} />,
		[MENU_ITEMS_VARIANTS.MENU_ITEMS_1047]: (data) => <NavBar1047 data={data} />,
		[MENU_ITEMS_VARIANTS.MENU_ITEMS_1060]: (data) => <NavBar1060 data={data} />,
	},
	[SECTION_TYPES.SUBSCRIBE]: {
		[SUBSCRIBE_VARIANTS.SUBSCRIBE_1]: (data) => <Subscribe1 data={data} />,
	},
	[SECTION_TYPES.PROGRAM_CARDS]: {
		[PROGRAM_CARDS_VARIANTS.PROGRAM_CARDS_1053]: (data) => (
			<ProgramCards1053 data={data} />
		),
		[PROGRAM_CARDS_VARIANTS.PROGRAM_CARDS_1067]: (data) => (
			<ProgramCards1067 data={data} />
		),
		[PROGRAM_CARDS_VARIANTS.PROGRAM_CARDS_1070]: (data) => (
			<ProgramCards1070 data={data} />
		),
		[PROGRAM_CARDS_VARIANTS.PROGRAM_CARDS_1]: (data) => (
			<ProgramCards1 data={data} />
		),
		[PROGRAM_CARDS_VARIANTS.PROGRAM_CARDS_2]: (data) => (
			<ProgramCards2 data={data} />
		),
		[PROGRAM_CARDS_VARIANTS.PROGRAM_CARDS_3]: (data) => (
			<ProgramCards3 data={data} />
		),
		[PROGRAM_CARDS_VARIANTS.PROGRAM_CARDS_4]: (data) => (
			<ProgramCards4 data={data} />
		),
		[PROGRAM_CARDS_VARIANTS.PROGRAM_CARDS_BLOG_1]: (data) => (
			<BlogProgramCards1 data={data} />
		),
		[PROGRAM_CARDS_VARIANTS.PROGRAM_CARDS_1027]: (data) => (
			<ProgramCards1027 data={data} />
		),
		[PROGRAM_CARDS_VARIANTS.PROGRAM_CARDS_1038]: (data) => (
			<ProgramCards1038 data={data} />
		),
		[PROGRAM_CARDS_VARIANTS.PROGRAM_CARDS_1045]: (data) => (
			<ProgramCards1045 data={data} />
		),
		[PROGRAM_CARDS_VARIANTS.PROGRAM_CARDS_6002]: (data) => (
			<ProgramCards6002 data={data} />
		),
	},
	[SECTION_TYPES.THANK_YOU]: {
		[THANK_YOU_VARIANTS.THANK_YOU_1]: (data) => <ThankYou1 data={data} />,
		[THANK_YOU_VARIANTS.THANK_YOU_1009]: (data) => <ThankYou1009 data={data} />,
	},
	[SECTION_TYPES.REFERRAL_FORM]: {
		[REFERRAL_FORM_VARIANTS.REFERRAL_FORM_1]: (data) => (
			<ReferralForm1 data={data} />
		),
		[REFERRAL_FORM_VARIANTS.REFERRAL_FORM_1008]: (data) => (
			<ReferralForm1008 data={data} />
		),
		[REFERRAL_FORM_VARIANTS.REFERRAL_FORM_1048]: (data) => (
			<ReferralForm1048 data={data} />
		),
	},

	[SECTION_TYPES.INFLUENCER_FORM]: {
		[INFLUENCER_FORM_VARIANTS.INFLUENCER_FORM_1]: (data) => (
			<InfluencerFormWrapper1 data={data} />
		),
		[INFLUENCER_FORM_VARIANTS.INFLUENCER_FORM_1007]: (data) => (
			<InfluencerFormWrapper1007 data={data} />
		),
		[INFLUENCER_FORM_VARIANTS.INFLUENCER_FORM_1049]: (data) => (
			<InfluencerFormWrapper1049 data={data} />
		),
	},
	[SECTION_TYPES.GRIEVANCE_FORM]: {
		[GRIEVANCE_FORM_VARIANTS.GRIEVANCE_FORM_1]: (data) => (
			<GrievanceForm1 data={data} />
		),
	},
	[SECTION_TYPES.RICH_TEXT_EDITOR]: {
		[RICH_TEXT_EDITOR_VARIANTS.RICH_TEXT_EDITOR_1]: (data) => (
			<RichTextEditor1 data={data} />
		),
		[RICH_TEXT_EDITOR_VARIANTS.RICH_TEXT_EDITOR_6001]: (data) => (
			<RichTextEditor6001 data={data} />
		),
	},
	[SECTION_TYPES.BLOG_WITH_LEAD]: {
		[BLOG_WITH_LEAD_VARIANTS.BLOG_WITH_LEAD_1]: (data) => (
			<BlogWithLead1 data={data} />
		),
	},
	[SECTION_TYPES.LATEST_BLOGS]: {
		[LATEST_BLOGS_VARIANTS.LATEST_BLOGS_1]: (data) => (
			<LatestBlogs1 data={data} />
		),
		[LATEST_BLOGS_VARIANTS.LATEST_BLOGS_2]: (data) => (
			<LatestBlogs2 data={data} />
		),
	},
	[SECTION_TYPES.POPULAR_BLOGS]: {
		[POPULAR_BLOGS_VARIANTS.POPULAR_BLOGS_1]: (data) => (
			<PopularBlogs1 data={data} />
		),
	},
	[SECTION_TYPES.BLOG_LIST]: {
		[BLOG_LIST_VARIANTS.BLOG_LIST_1]: (data) => (
			<BlogList1 data={data} />
		),
	},
	[SECTION_TYPES.COUNSELOR_CALL_CTA]: {
		[COUNSELOR_CALL_CTA_VARIANTS.COUNSELOR_CALL_CTA_1]: (data) => (
			<CounselorCallCta1 data={data} />
		),
	},
	[SECTION_TYPES.BREADCRUMB_BANNER]: {
		[BREADCRUMB_BANNER_VARIANTS.BREADCRUMB_BANNER_1]: (data) => (
			<BreadcrumbBanner1 data={data} />
		),
	},
	[SECTION_TYPES.BLOG_INLINE_IMAGE]: {
		[BLOG_INLINE_IMAGE_VARIANTS.BLOG_INLINE_IMAGE_1]: (data) => (
			<BlogInlineImage1 data={data} />
		),
	},
	[SECTION_TYPES.PARA_TEXT]: {
		[PARA_TEXT_VARIANTS.PARA_TEXT_1]: (data) => <ParaText1 data={data} />,
	},
	[SECTION_TYPES.ELIGIBILITY]: {
		[ELIGIBILITY_VARIANTS.ELIGIBILITY_1]: (data) => (
			<EligibilityCriteria data={data} />
		),
		[ELIGIBILITY_VARIANTS.ELIGIBILITY_2]: (data) => (
			<Eligibility2 data={data} />
		),
		[ELIGIBILITY_VARIANTS.ELIGIBILITY_1041]: (data) => (
			<Eligibility1041 data={data} />
		),
		[ELIGIBILITY_VARIANTS.ELIGIBILITY_5012]: (data) => <Eligibility5012 data={data} />,
	},
	[SECTION_TYPES.CAREER_PROSPECTS]: {
		[CAREER_PROSPECTS_VARIANTS.CAREER_PROSPECTS_1]: (data) => (
			<CareerProspects1 data={data} />
		),
		[CAREER_PROSPECTS_VARIANTS.CAREER_PROSPECTS_2]: (data) => (
			<CareerProspects2 data={data} />
		),
		[CAREER_PROSPECTS_VARIANTS.CAREER_PROSPECTS_3]: (data) => (
			<CareerProspects3 data={data} />
		),
		[CAREER_PROSPECTS_VARIANTS.CAREER_PROSPECTS_4]: (data) => (
			<CareerProspects4 data={data} />
		),
	},
	[SECTION_TYPES.SPECIALISATION]: {
		[SPECIALISATION_VARIANTS.SPECIALISATION_1]: (data) => (
			<Specialisation1 data={data} />
		),
		[SPECIALISATION_VARIANTS.SPECIALISATION_5017]: (data) => (
			<Specialisation5017 data={data} />
		),
	},
	[SECTION_TYPES.SUCCESS_STORIES]: {
		[SUCCESS_STORIES_VARIANTS.SUCCESS_STORIES_1]: (data) => (
			<SuccessStories1 data={data} />
		),
		[SUCCESS_STORIES_VARIANTS.SUCCESS_STORIES_2]: (data) => (
			<StudentShowcase data={data} />
		),
	},
	[SECTION_TYPES.WHAT_MAKES_COURSE_DIFFERENT]: {
		[WHAT_MAKES_COURSE_DIFFERENT_VARIANTS.WHAT_MAKES_COURSE_DIFFERENT_1]: (
			data,
		) => <WhatMakesCourseDifferent1 data={data} />,
		// [WHAT_MAKES_COURSE_DIFFERENT_VARIANTS.WHAT_MAKES_COURSE_DIFFERENT_2]: (
		//   data,
		// ) => <WhatMakesCourseDifferent2 data={data} />,
	},
	[SECTION_TYPES.ELECTIVE]: {
		[ELECTIVE_VARIANTS.ELECTIVE_1]: (data) => <Elective1 data={data} />,
		[ELECTIVE_VARIANTS.ELECTIVE_1065]: (data) => <Elective1065 data={data} />,
	},

	[SECTION_TYPES.PROGRAM_STRUCTURE]: {
		[PROGRAM_STRUCTURE_VARIANTS.PROGRAM_STRUCTURE_1]: (data) => (
			<ProgramStructure1 data={data} />
		),

		[PROGRAM_STRUCTURE_VARIANTS.PROGRAM_STRUCTURE_2]: (data) => (
			<ProgramStructure2 data={data} />
		),
		[PROGRAM_STRUCTURE_VARIANTS.PROGRAM_STRUCTURE_3]: (data) => (
			<ProgramStructure3 data={data} />
		),
		[PROGRAM_STRUCTURE_VARIANTS.PROGRAM_STRUCTURE_4]: (data) => (
			<ProgramStructure4 data={data} />
		),
		[PROGRAM_STRUCTURE_VARIANTS.PROGRAM_STRUCTURE_5]: (data) => (
			<ProgramStructure5 data={data} />
		),
		[PROGRAM_STRUCTURE_VARIANTS.PROGRAM_STRUCTURE_1042]: (data) => (
			<ProgramStructure1042 data={data} />
		),
		[PROGRAM_STRUCTURE_VARIANTS.PROGRAM_STRUCTURE_1064]: (data) => (
			<ProgramStructure1064 data={data} />
		),
	},

	[SECTION_TYPES.PROGRAM_FEE]: {
		[PROGRAM_FEE_VARIANTS.PROGRAM_FEE_1]: (data) => <ProgramFee1 data={data} />,
		[PROGRAM_FEE_VARIANTS.PROGRAM_FEE_2]: (data) => <ProgramFee2 data={data} />,
		// Variant 3 renders the dedicated "Program Fees" multi-tab design directly.
		[PROGRAM_FEE_VARIANTS.PROGRAM_FEE_3]: (data) => (
			<ProgramFee2Variant3 data={data} />
		),
		[PROGRAM_FEE_VARIANTS.PROGRAM_FEE_1043]: (data) => (
			<ProgramFee1043 data={data} />
		),
		[PROGRAM_FEE_VARIANTS.PROGRAM_FEE_1066]: (data) => (
			<ProgramFee1066 data={data} />
		),
	},
	[SECTION_TYPES.MOBILE_LEAD_FORM]: {
		[MOBILE_LEAD_FORM_VARIANTS.MOBILE_LEAD_FORM_1]: (data) => (
			<MobileLeadForm1 data={data} />
		),
		[MOBILE_LEAD_FORM_VARIANTS.MOBILE_LEAD_FORM_2]: (data) => (
			<MobileLeadForm2 data={data} />
		),
		[MOBILE_LEAD_FORM_VARIANTS.MOBILE_LEAD_FORM_6]: (data) => (
			<MobileLeadForm6 data={data} />
		),
	},
	[SECTION_TYPES.COUNSELING]: {
		[COUNSELING_VARIANTS.COUNSELING_1]: (data) => (
			<GetFreeCounselling1 data={data} />
		),
	},
	[SECTION_TYPES.PROGRAM_PROSPECTS]: {
		[PROGRAM_PROSPECTS_VARIANTS.PROGRAM_PROSPECTS_1]: (data) => (
			<ProgramProspects1 data={data} />
		),
	},
	[SECTION_TYPES.COURSE_SPECIALISATIONS]: {
		[COURSE_SPECIALISATIONS_VARIANTS.COURSE_SPECIALISATIONS_1]: (data) => (
			<CourseSpecialisation1 data={data} />
		),
	},
	[SECTION_TYPES.EXAMINATION_GUIDELINES]: {
		[EXAMINATION_GUIDELINES_VARIANTS.EXAMINATION_GUIDELINES_1]: (data) => (
			<ExaminationGuidelines1 data={data} />
		),
	},
	[SECTION_TYPES.LIVE_LECTURE]: {
		[LIVE_LECTURE_VARIANTS.LIVE_LECTURE_1]: (data) => (
			<LiveLecture1CSR data={data} />
		),
		[LIVE_LECTURE_VARIANTS.LIVE_LECTURE_1011]: (data) => (
			<LiveLecture1011CSR data={data} />
		),
		[LIVE_LECTURE_VARIANTS.LIVE_LECTURE_1050]: (data) => (
			<LiveLecture1050CSR data={data} />
		),
	},

	[SECTION_TYPES.PROGRAM_BENEFITS]: {
		[PROGRAM_BENEFITS_VARIANTS.PROGRAM_BENEFITS_1]: (data) => (
			<ProgramBenefits1 data={data} />
		),
		// Variant 2 renders the one-cms "Program Benefits 2" (cards + CTA), not the
		// standalone degree-grid — it reads the program_benefits_2 model, matching how
		// variant-2 data is authored on the multi-tenant backend.
		[PROGRAM_BENEFITS_VARIANTS.PROGRAM_BENEFITS_2]: (data) => (
			<ProgramBenefits2 data={data} />
		),
		[PROGRAM_BENEFITS_VARIANTS.PROGRAM_BENEFITS_3]: (data) => (
			<ProgramBenefitsGrid3 data={data} />
		),
		[PROGRAM_BENEFITS_VARIANTS.PROGRAM_BENEFITS_4]: (data) => (
			<ProgramBenefitsCourseFee data={data} />
		),
		[PROGRAM_BENEFITS_VARIANTS.PROGRAM_BENEFITS_5]: (data) => (
			<ProgramBenefits2 data={data} />
		),
		[PROGRAM_BENEFITS_VARIANTS.PROGRAM_BENEFITS_6]: (data) => (
			<ProgramBenefitsFeePlan data={data} />
		),
		[PROGRAM_BENEFITS_VARIANTS.PROGRAM_BENEFITS_7]: (data) => (
			<ProgramBenefitsPracticalSkills data={data} />
		),
		// Degree grid. Was variant "2" until unified-tenancy claimed that id for the
		// carousel; the component and its `program_benefits_12` field set are unchanged.
		[PROGRAM_BENEFITS_VARIANTS.PROGRAM_BENEFITS_3000]: (data) => (
			<ProgramBenefitsGrid2 data={data} />
		),
		[PROGRAM_BENEFITS_VARIANTS.PROGRAM_BENEFITS_1005]: (data) => (
			<ProgramBenefits1005 data={data} />
		),
		[PROGRAM_BENEFITS_VARIANTS.PROGRAM_BENEFITS_1029]: (data) => (
			<ProgramBenefits1029 data={data} />
		),
		[PROGRAM_BENEFITS_VARIANTS.PROGRAM_BENEFITS_1040]: (data) => (
			<ProgramBenefits1040 data={data} />
		),
		[PROGRAM_BENEFITS_VARIANTS.PROGRAM_BENEFITS_1044]: (data) => (
			<ProgramBenefits1044 data={data} />
		),
		[PROGRAM_BENEFITS_VARIANTS.PROGRAM_BENEFITS_5008]: (data) => <ProgramBenefits5008 data={data} />,
		[PROGRAM_BENEFITS_VARIANTS.PROGRAM_BENEFITS_5009]: (data) => <ProgramBenefits5009 data={data} />,
		[PROGRAM_BENEFITS_VARIANTS.PROGRAM_BENEFITS_1063]: (data) => <ProgramBenefits1063 data={data} />,
		[PROGRAM_BENEFITS_VARIANTS.PROGRAM_BENEFITS_1069]: (data) => <ProgramBenefits1069 data={data} />,
	},

	[SECTION_TYPES.COURSE_OUTCOME]: {
		[COURSE_OUTCOME_VARIANTS.COURSE_OUTCOME_1]: (data) => (
			<CourseOutcome1 data={data} />
		),
		[COURSE_OUTCOME_VARIANTS.COURSE_OUTCOME_2]: (data) => (
			<CourseOutcome2 data={data} />
		),
	},

	[SECTION_TYPES.CERTIFICATES]: {
		[CERTIFICATES_VARIANTS.CERTIFICATES_1]: (data) => (
			<Certificates1 data={data} />
		),
	},

	[SECTION_TYPES.SKILLS]: {
		[SKILLS_VARIANTS.SKILLS_1]: (data) => <Skills1 data={data} />,
	},
	[SECTION_TYPES.APPLICATION_PROCESS]: {
		[APPLICATION_PROCESS_VARIANTS.APPLICATION_PROCESS_1]: (data) => (
			<ApplicationProcess1 data={data} />
		),
		[APPLICATION_PROCESS_VARIANTS.APPLICATION_PROCESS_2]: (data) => (
			<ApplicationProcess2 data={data} />
		),
		[APPLICATION_PROCESS_VARIANTS.APPLICATION_PROCESS_1030]: (data) => (
			<ApplicationProcess1030 data={data} />
		),
		[APPLICATION_PROCESS_VARIANTS.APPLICATION_PROCESS_5011]: (data) => <ApplicationProcess5011 data={data} />,
	},
	[SECTION_TYPES.WHO_IS_THIS_PROGRAM_FOR]: {
		[WHO_IS_THIS_PROGRAM_FOR_VARIANTS.WHO_IS_THIS_PROGRAM_FOR_1]: (data) => (
			<WhoIsThisProgramFor1 data={data} />
		),
	},
	[SECTION_TYPES.BANNER_VIDEO]: {
		[BANNER_VIDEO_VARIANTS.BANNER_VIDEO_1]: (props) => (
			<BannerVideo1 {...props} />
		),
	},
	[SECTION_TYPES.WALK_THROUGH]: {
		[WALK_THROUGH_VARIANTS.WALK_THROUGH_1]: (data) => (
			<WalkThrough1 data={data} />
		),
	},
	[SECTION_TYPES.LIFE_MILESTONE]: {
		[LIFE_MILESTONE_VARIANTS.LIFE_MILESTONE_1]: (data) => (
			<LifeMilestone1 data={data} />
		),
		[LIFE_MILESTONE_VARIANTS.LIFE_MILESTONE_2]: (data) => (
			<LifeMilestone2 data={data} />
		),
		[LIFE_MILESTONE_VARIANTS.LIFE_MILESTONE_3]: (data) => (
			<LifeMilestone3 data={data} />
		),
	},
	[SECTION_TYPES.ENROLLMENTS]: {
		[ENROLLMENTS_VARIANTS.ENROLLMENTS_1]: (data) => (
			<Enrollments1 data={data} />
		),
		[ENROLLMENTS_VARIANTS.ENROLLMENTS_2]: (data) => (
			<Enrollments2 data={data} />
		),
		[ENROLLMENTS_VARIANTS.ENROLLMENTS_3]: (data) => (
			<Enrollments3 data={data} />
		),
		[ENROLLMENTS_VARIANTS.ENROLLMENTS_4]: (data) => (
			<Enrollments4 data={data} />
		),
		[ENROLLMENTS_VARIANTS.ENROLLMENTS_5]: (data) => (
			<Enrollments5 data={data} />
		),
	},
	[SECTION_TYPES.COMPARISON]: {
		[COMPARISON_VARIANTS.COMPARISON_1]: (data) => <Comparison1 data={data} />,
		[COMPARISON_VARIANTS.COMPARISON_1004]: (data) => <Comparison1004 data={data} />,
	},
	// [SECTION_TYPES.LEADERS]: {
	//   [LEADERS_VARIANTS.LEADERS_1]: (data) => <Leaders1 data={data} />,
	// },
	// [SECTION_TYPES.ABOUT]: {
	//   [ABOUT_VARIANTS.ABOUT_2]: (data) => <About2 data={data} />,
	// },

	[SECTION_TYPES.LEADERS]: {
		[LEADERS_VARIANTS.LEADERS_1]: (data) => <Leaders1 data={data} />,
		[LEADERS_VARIANTS.LEADERS_1032]: (data) => (
			<Leaders1032 data={data} />
		),
	},

	[SECTION_TYPES.CASE_STUDY]: {
		[CASE_STUDY_VARIANTS.CASE_STUDY_1]: (data) => <CaseStudy1 data={data} />,
	},

	[SECTION_TYPES.BRAND]: {
		[BRAND_VARIANTS.BRAND_1]: (data) => <Brand1 data={data} />,
	},

	[SECTION_TYPES.INSTITUTES]: {
		[INSTITUTES_VARIANTS.INSTITUTES_1]: (data) => <Institutes1 data={data} />,
	},

	[SECTION_TYPES.AUTHOR_PROFILE]: {
		[AUTHOR_PROFILE_VARIANTS.AUTHOR_PROFILE_1]: (props) => (
			<AuthorProfile1 data={props} author={props?.author} />
		),
	},
	/* Both author widgets self-gate: they return null unless the page is a blog
	   WITH an author linked, so they are safe to leave on any page. */
	[SECTION_TYPES.AUTHOR_CARD]: {
		[AUTHOR_CARD_VARIANTS.AUTHOR_CARD_1]: (props) => <AuthorCard1 {...props} />,
	},
	[SECTION_TYPES.AUTHOR_BYLINE]: {
		[AUTHOR_BYLINE_VARIANTS.AUTHOR_BYLINE_1]: (props) => (
			<AuthorByline1 {...props} />
		),
	},
	[SECTION_TYPES.HEADING]: {
		[HEADING_VARIANTS.HEADING_1]: (data) => <Heading1 data={data} />,
	},
	[SECTION_TYPES.SPECIALISATION_CAROUSEL]: {
		[SPECIALISATION_CAROUSEL_VARIANTS.SPECIALISATION_CAROUSEL_1]: (data) => (
			<SpecialisationCarousel3000 data={data} />
		),
	},

	[SECTION_TYPES.SKILL_CARDS]: {
		[SKILL_CARDS_VARIANTS.SKILL_CARDS_1]: (data) => <SkillCards1 data={data} />,
	},

};

export const LEAD_DROP_POPUP_SECTION_VARIANTS = {
	[LEAD_DROP_POPUP_VARIANTS.LEAD_DROP_POPUP_1]: Leaddrop1,
	[LEAD_DROP_POPUP_VARIANTS.LEAD_DROP_POPUP_2]: Leaddrop2,
	[LEAD_DROP_POPUP_VARIANTS.LEAD_DROP_POPUP_3]: Leaddrop3,
	[LEAD_DROP_POPUP_VARIANTS.LEAD_DROP_POPUP_4]: Leaddrop4,
	[LEAD_DROP_POPUP_VARIANTS.LEAD_DROP_POPUP_7]: Leaddrop7,
	[LEAD_DROP_POPUP_VARIANTS.LEAD_DROP_POPUP_6]: Leaddrop6,
	[LEAD_DROP_POPUP_VARIANTS.LEAD_DROP_POPUP_8]: Leaddrop8,
	[LEAD_DROP_POPUP_VARIANTS.LEAD_DROP_POPUP_9]: Leaddrop9,
	[LEAD_DROP_POPUP_VARIANTS.LEAD_DROP_POPUP_10]: Leaddrop10,
	[LEAD_DROP_POPUP_VARIANTS.LEAD_DROP_POPUP_2001]: Leaddrop2001,
	[LEAD_DROP_POPUP_VARIANTS.LEAD_DROP_POPUP_5002]: Leaddrop5002,
	[LEAD_DROP_POPUP_VARIANTS.LEAD_DROP_POPUP_5018]: Leaddrop5018,
};

export const LEAD_DROP_FORM_SECTION_VARIANTS = {
	[LEAD_DROP_FORM_VARIANTS.LEAD_DROP_FORM_1]: LeaddropForm1,
	[LEAD_DROP_FORM_VARIANTS.LEAD_DROP_FORM_2]: LeaddropForm2,
	[LEAD_DROP_FORM_VARIANTS.LEAD_DROP_FORM_3]: LeaddropForm3,
	[LEAD_DROP_FORM_VARIANTS.LEAD_DROP_FORM_4]: LeaddropForm4,
	[LEAD_DROP_FORM_VARIANTS.LEAD_DROP_FORM_6]: MultiStepIntakeForm,
	[LEAD_DROP_FORM_VARIANTS.LEAD_DROP_FORM_8]: LeaddropForm8,
	[LEAD_DROP_FORM_VARIANTS.LEAD_DROP_FORM_9]: LeaddropForm9,
	[LEAD_DROP_FORM_VARIANTS.LEAD_DROP_FORM_10]: LeaddropForm10,
	[LEAD_DROP_FORM_VARIANTS.LEAD_DROP_FORM_2001]: LeaddropForm2001,
	[LEAD_DROP_FORM_VARIANTS.LEAD_DROP_FORM_5002]: LeaddropForm5002,
	[LEAD_DROP_FORM_VARIANTS.CUSTOM_FORM]: CustomLeadForm,
	[LEAD_DROP_FORM_VARIANTS.LEAD_DROP_FORM_5018]: LeaddropForm5018,
};

export const LEAD_DROP_FORM_MOBILE_CTA_VARIANTS = {
	[LEAD_DROP_FORM_VARIANTS.LEAD_DROP_FORM_1]: LeaddropForm1MobileAboutCta,
	[LEAD_DROP_FORM_VARIANTS.LEAD_DROP_FORM_2]: LeaddropForm2MobileAboutCta,
	[LEAD_DROP_FORM_VARIANTS.LEAD_DROP_FORM_6]: MultiStepIntakeFormMobileAboutCta,
	[LEAD_DROP_FORM_VARIANTS.LEAD_DROP_FORM_8]: LeaddropForm8MobileAboutCta,
	[LEAD_DROP_FORM_VARIANTS.LEAD_DROP_FORM_9]: LeaddropForm9MobileAboutCta,
	[LEAD_DROP_FORM_VARIANTS.LEAD_DROP_FORM_10]: LeaddropForm10MobileAboutCta,
	[LEAD_DROP_FORM_VARIANTS.LEAD_DROP_FORM_2001]: LeaddropForm2001MobileAboutCta,
	[LEAD_DROP_FORM_VARIANTS.LEAD_DROP_FORM_5002]: LeaddropForm5002MobileAboutCta,
	/**
	 * Mobile renders the FULL custom form, not a "tap to open" button — the same choice
	 * lead form 9 makes. A skin's embedded card is already responsive top to bottom, and a
	 * CTA that opens a dialog would put the visitor into the popup tree, which may be a
	 * different journey than the one this page was configured with.
	 */
	[LEAD_DROP_FORM_VARIANTS.CUSTOM_FORM]: CustomLeadForm,
	[LEAD_DROP_FORM_VARIANTS.LEAD_DROP_FORM_5018]: LeaddropForm5018MobileAboutCta,
};

export const ROUTES = {
	SLUG_1: 1,
	SLUG_2: 2,
	SLUG_3: 3,
};

export const PAGE_TYPES = {
	HOME: "home",
	PROGRAM: "program",
	SPECIALISATION: "specialisation",
	AUXILIARY: "auxiliary",
	LANDING_HOME: "landing_home",
	LANDING_PROGRAM: "landing_program",
	OTHERS: "others",
	BLOG: "blog",
};
